const translations = () => ({
  error503: {
    errorCode: '503',
    title: "We'll be back online soon!",
    subTitle:
      'Hello, for a system update, the BDroppy platform may not be available for a few hours.',
    cta: 'Home',
  },
  home: {
    hello: 'Hello',
    bonusMessage: '💰 10€ di bonus sul primo acquisto',
    welcomeLink: '/product',
    welcomeBG: 'red',
    welcomeColor: '#ccc',
    videoTitle: 'BDroppy in 30 seconds',
    whatToDo: 'How it works',
    startShopping: 'Start shopping online on BDroppy now',
    seeProduct: 'See products',
    viewAll: 'View all',
    titleRoleUSer: 'Hi',
    faqAndTutorial: 'FAq and tutorial',
    apartFrom:
      'Apart from using BDroppy as a platform to start or boost your online business, you also have the option to shop for yourself, safely and conveniently!',
    becomeReseller:
      'Become a Reseller: Start Making Money In Three Simple Steps',
    seeCatalog: 'Category',
    cardText1: 'The easiest way to sell designer',
    cardText2: 'fashion in dropshipping',
    cta: 'Choose your plan',
    discoverTitle: 'Discovering BDroppy',
    discoverDescription:
      'Watch our webinar and find out how easy it is to use BDroppy',
    bookCall: 'Book a free call',
    weeklyArrivals:
      'New weekly arrivals for your dropshipping business: Gucci, Harmont & Blaine, Trussardi, Napapijri',
    readArticle: 'Read the article',
    emailConfirm: 'You have to confirm email in order to activate account',
    checkEmail: 'Check your email or click to resend.',
    resendEmail: 'Resend email',
    emailSent: 'Email sent correctly check your email please',
    role: 'Free role',
    step1: 'Step 1',
    step2: 'Step 2',
    step3: 'Step 3',
    confirmEmail: 'Confirm email',
    close: 'Close',
    limitedTimeOffer: 'Limited time offer',
    expired: 'Expired in',
    yourCashback: 'Cashback balance',
    welcome: 'Welcome on BDroppy',
    discount: 'of discount',
    only72h: 'Solo per 72h',
    videos: {
      title: 'Get an overview',
      title2: 'How to create your first list',
      title3: 'How to chose a channel',
    },
    coach: {
      videoTitle: 'Ask the coach',
      videoDescription:
        'Do you have any doubts or questions about Amazon FBA? This webinar is for you!',
      newEpisode: 'New episode',
      href: 'https://www.youtube.com/playlist?list=PLx_gWhKuj-EO7il_OPJwC82Loq85bOfI7',
      cta: 'See all video',
    },
    howToStartTitle: 'How to start',
    howToStartFree: {
      tab: 'Your role: Free',
      title: 'Cosa puoi fare? ',
      subtitle:
        'Fino a 5 ordini manuali al mese inclusi, acquisti a prezzi di ingrosso, senza costi di servizio!',
      li_1: '1 - Scegli i prodotti che vuoi acquistare e vendere ',
      li_2: '2 - Mostrali ai tuoi amici e conoscenti',
      li_3: "3 - concludi l'ordine su BDroppy",
      li_4: '4 - guadagna dalle tue vendite senza costi di transazione',
      li_5: '4 - guadagna dalle tue vendite senza costi di transazione',
      cta: 'Vai al catalogo',
    },
    howToStart1: {
      tab: 'Select products',
      title:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
      subtitle:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
      cta: 'Select products',
    },
    howToStart2: {
      tab: 'Create import list',
      title:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
      subtitle:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
      cta: 'Create your list',
    },
    howToStart3: {
      tab: 'Choose a channel',
      title:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
      subtitle:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
      cta: 'Choose your channel',
    },
    dismiss: 'Dismiss',
    blog: 'Latest from the blog',
    tutorial: 'FAQ e Tutorials',
    tutorialDescription:
      'Find out how to best use BDroppy thanks to our insights.',
    tutorialImg:
      'https://bdroppy.com/wp-content/uploads/2022/02/faq-and-tutorials.jpg',
    viewTutorial: 'View tutorial',
    bestSellers: 'Best sellers',
    category_1: 'Clothing',
    category_2: 'Bags',
    category_3: 'Shoes',
    category_4: 'Accessories',
    category_5: 'Underwear',
    category_6: 'Bellezza',
    stepFree_1: '1. Select products',
    stepFree_2: '2. Choose your plan',
    stepFree_3: '3. You sell, we ship',
    goPlan: 'Vai ai piani',
    about: 'Chi siamo',
    myLists: 'My list',
    imperdibili: 'Unmissable',
    bestSeller: 'Best sellers',
    blackFriday: 'Black friday',
    reseller: 'Become reseller',
    affiliation: 'Become affiliated',
    resellerText:
      'Fai crescere il tuo business online rivendendo [resellerText2], senza rischi di magazzino',
    resellerText2: 'grandi marchi moda',
    affiliationText:
      'Diventa un partner affiliato e [affiliationText2] su ogni acquisto del cliente da te segnalato',
    affiliationText2: 'guadagna fino all’ X%',
    productCatalog: 'Product catalog',
  },
  header: {
    menu: 'Menu',
    resellerArea: 'Reseller area',
    subheader: {
      man: 'Man',
      woman: 'Donna',
      accessories: 'Accessories',
      bags: 'Bags',
      clothing: 'Clothing',
      underwear: 'Underwear',
      beauty: 'Beauty',
      shoes: 'Shoes',
      brands: 'Brands',
      reseller: 'Become a reseller',
      discoverPlan: 'Discover plan',
      cashback: "You've reached the max cash amount of [cashback_2]",
      cashback_2: 'activate the plan social to earn more cashback',
      youEarn: 'You already earn',
      shareYourWishlist: 'Share your wishlist',
    },
    headerPublic: {
      text1: '[highlight] IMMEDIATO, anche sugli acquisti [highlight2]',
      highlight1: '10% di cashback',
      highlight2: 'dei tuoi amici!',
      text2: 'E sul primo acquisto ricevi [highlight]',
      highlight3: '10€ di bonus',
      CTA: 'Scopri il catalogo',
    },
    wishlist: {
      title: 'Create an account!',
      content:
        'You can create and share you wishlist content only if you have an account',
      CTA: 'Register',
    },
  },
  footer: {
    company: 'Company',
    blog: 'Blog',
    about: 'About',
    resources: 'Resources',
    shippingFees: 'Shipping fees',
    images: 'Marketing Videos & Images',
    pricing: 'Pricing',
    partners: 'Area partners & Business',
    affiliation: 'Affiliation',
    reseller: 'Reseller',
    eFranchising: 'E-franchising',
    onlyOne: 'Be the only one',
    help: 'Help',
    faq: 'Faq & tutorial',
    tutorial: 'Tutorial',
    shipping: 'Shipped',
    paymentMethod: 'Payment method',
    privacy: 'Privacy policy',
    terms: 'Terms and conditions',
    bdroppy: '© BDroppy 2023',
    contactUs: 'Contact us',
    cashback: 'Cashback',
    howToReturn: 'How to ask for a return',
    influencer: 'Influencer program',
    bookACall: 'Book a call',
  },
  promo: {
    timer: {
      seconds: 'Seconds',
      days: 'Days',
      hours: 'Hours',
      minutes: 'Minutes',
    },
  },
  notifications: {
    title: 'Notifications',
    noOrderToPay: 'You have 0 unpaid orders',
    subtitle: 'You have some order to pay',
    viewAll: 'View all',
    payNow: 'Pay now',
    date: 'Date',
    total: 'Total',
  },
  pricing: {
    gratis: 'Gratis',
    activePlan: 'Plan already activate',
    tutorialBsocial: 'Guarda il nostro tutorial',
    downloadExampleFile: 'Download the example file',
    bsocialPromo: 'Solo per pochi giorni',
    title: 'Our Pricing Plans',
    news: 'New',
    newPlan: 'Il più economico',
    wixInfo:
      'For the payment you will be redirect to wix.com, please select a plan',
    tab1: 'Dropshipping plans',
    tab2: 'Do you want a turnkey site?',
    bookACallLong:
      'Discover how BDroppy can change your online business, book a call',
    tab3: 'Vuoi vendere moda SENZA bisogno di un ecommerce?',
    monthly: 'Monthly',
    yearly: 'Yearly',
    mostPopular: 'Most popular',
    cashback: 'Cashback 10%',
    showMore: 'Show details',
    findMore: 'Discover more',
    seeTemplate: 'See template',
    buy: 'Buy',
    billedAnnually: 'Billed annually',
    month: 'month',
    year: 'year',
    startFreeTrial: 'Start free trial',
    startNow: 'Start now',
    save: 'You are saving',
    descriptionPlan: '*description plan',
    descriptionEasy:
      'Best for new ecommerce businesses with occasional in-person sales',
    descriptionBasic:
      'Best for new ecommerce businesses with occasional in-person sales',
    descriptionPlus: 'Best for growing businesses selling online or in-store',
    descriptionEnterprise:
      'Best for new ecommerce businesses with occasional in-person sales',
    descriptionShopify:
      'Best for new ecommerce businesses with occasional in-person sales',
    descriptionEasySite: 'Piano dropshipping Basic in regalo per un anno!',
    descriptionStarter: 'Ideal for starting your online business in fashion',
    descriptionBSocial: 'Condividi e vendi sui tuoi social network preferiti',
    descriptionLight:
      'Esporta tutto il catalogo in formato xls, csv, xml, json e crea i tuoi ordini manualmente',
    drop: {
      title: 'Grow your dropshipping business',
      paragraph:
        'Choose how to integrate the BDroppy catalog into your ecommerce or marketplace',
    },
    createCatalog:
      "Looks like you don't have a list, create your first list to start selling on Wix",
    createCatalogCTA: 'Create list',
    turnkey: {
      title: 'Or choose a turnkey website',
      paragraph:
        'We create your ready-to-use e-commerce for you, with integrated fashion catalog and dropshipping service included',
    },
    bsocial: {
      title: 'Vuoi vendere moda SENZA bisogno di un ecommerce?',
      paragraph:
        'Condividi e vendi sui tuoi social network preferiti in un click',
      activationBsocial: 'You can activate BSocial directly from your channels',
      socialVideoTutorial: 'https://youtu.be/PEWf87rQfKc',
    },
    infoBanner: {
      title:
        'Would you like to receive a custom quote or do you want to use our API?',
      subTitle: 'Book a call with one of our representatives now',
      cta: 'Book a call',
      shopifyTitle: 'Vendi su Shopify?',
      shopifySubtitle:
        'Questo è il piano che devi attivare! Il collegamento avverrà direttamente con il fornitore',
      turnkeyTitle:
        'Hai un budget da dedicare ad un progetto personalizzato e su misura per te? ',
      turnkeySubTitle:
        'Profilati nel form sottostante e una nostra esperta ti ricontatterà',
      turnkeyCta: 'Compila il modulo',
    },
    discount: {
      discountEasy: '20%',
      discountBasic: '40%',
      discountPlus: '60%',
      discountEnterprise: '25%',
      discountStarter: '30%',
      discountEasySite: '-40%',
      discountBsocial: 'Up to 40% discount',
      staiRisparmiandoLight: 'you are saving',
      staiRisparmiandoBasic: 'you are saving',
      staiRisparmiandoPlus: 'you are saving',
      staiRisparmiandoBsocial: 'you are saving',
      mesiInRegaloBasic: 'free months',
      mesiInRegaloPlus: 'free months',
      mesiInRegaloLight: 'free months',
      mesiInRegaloBsocial: 'free months',
      discountLight: '-10%',
      yearly: 'Risparmia fino a 7 mesi',
      monthDiscount: 'Up to 40% discount',
      limitedTimeOffer: 'LIMITED TIME OFFER',
    },
    modal: {
      shopifyTitle:
        'Install the Brandssync app for Shopify and start your free trial',
      subtitle:
        '*Enter your Shopify store link, you will be redirected directly to the Shopify App Store',
      question: 'Don’t have a Shopify store yet? ',
      createNow: 'Create it now',
      text: 'With BrandsSync you can import Brandsdistribution’s fashion catalog into your Shopify store and sell the best fashion brands in dropshipping.',
      visitApp: 'Visit the App Store',
      alert: 'Insert valid shop name',
      template: 'Template',
      templateDescription:
        'Watch our demos and choose the look you want for your web store.',
      viewTemplate: 'View template',
      upgrade: 'Upgrade--->if you want a turnkey lose your channel',
      downgrade: 'Downgrade---> you will lose catalog',
      noTurnkey: 'noTurnkey---> you will lose turnkey',
      changePlan: 'Change plan',
      goBack: 'Go back',
      confirm: 'Continue',
      submit: 'Submit',
      login: 'Login',
    },
    shopify: {
      title: 'Shopify plan',
      listTitle:
        'HERE ARE THE ADVANTAGES OF THE EXCLUSIVE BANDSSYNC APP FOR SHOPIFY',
      features1: 'A catalog with over 100 top fashion brands',
      features2: '100% original branded fashion products',
      features3: 'Fast and reliable shipping from Italy',
      features4: 'Professional photos for your marketing campaigns',
      features5: 'Multilingual and multicurrency management',
      features6: 'Automatic synchronization of orders and quantities',
      howitWorksTitle1: 'DOWNLOAD THE APP',
      howitworks1:
        'Download BrandsSync and set up your account. Try it for free for 15 days!',
      howitWorksTitle2: 'IMPORT THE CATALOGUE',
      howitworks2:
        'Import the entire catalogue or select only the categories or products you want to sell in your Shopify store.',
      howitWorksTitle3: 'SET THE MARK UP',
      howitworks3:
        'Set the price and the mark up of your products and decide how much you earn from your sales.',
      howitWorksTitle4: 'SELL THE PRODUCTS',
      howitworks4:
        'Start selling designer clothing and fashion accessories without further investments in warehousing and logistics.',
      howitWorksTitle5: 'PAY THE ORDERS',
      howitworks5:
        'Once you have received an order on your Shopify store, access Brandsdistribution to proceed with the payment.',
      howitWorksTitle6: 'RELAX AND EARN',
      howitworks6:
        'Brandsdistribution ships the products directly to your customers through international couriers.',
      howitWorksTitleSection: 'HOW IT WORKS',
      needHelp: 'Do you need help?',
      pleaseNote:
        'PLEASE NOTE that you can use your BDroppy username and password to access Brandsdistribution.com',
    },
    faq: {
      title: 'Most common questions',
      question_1:
        'Do I have to sell the same products in-store as I do online?',
      answer_1:
        'No, you can choose exactly what products to sell online, in-store, or both.',
      question_2:
        'Do I have to sell the same products in-store as I do online?',
      answer_2:
        'No, you can choose exactly what products to sell online, in-store, or both.',
      question_3:
        'Do I have to sell the same products in-store as I do online?',
      answer_3:
        'No, you can choose exactly what products to sell online, in-store, or both.',
      question_4:
        'Do I have to sell the same products in-store as I do online?',
      answer_4:
        'No, you can choose exactly what products to sell online, in-store, or both.',
      question_bsocial:
        'Do I have to sell the same products in-store as I do online?',
      answer_bsocial:
        'No, you can choose exactly what products to sell online, in-store, or both.',
    },
    upsell: {
      title: 'Aumenta le conversioni del tuo store Shopify',
      subtitle:
        'Scopri [logo], la prima chat integrata con [t1] che incrementa le vendite, traccia gli ordini, consiglia i prodotti e [t2]. [cta]',
      t1: 'ChatGPT 4.0',
      t2: 'assiste i tuoi clienti 24/7',
      tryIt: 'Provala gratuitamente per 14 giorni',
    },
  },
  orders: {
    table: {
      actions: 'Actions',
      status: 'Status',
      statuses: {
        0: 'Pending',
        1: 'Payment waiting',
        2: 'Confirmed',
        3: 'Dispatched',
        5: 'Booked',
        2000: 'Failed',
        2001: 'No available',
        2002: 'Unknown',
        2003: 'API error',
        3001: 'Working on',
        3002: 'Ready',
        alternativeLabel_0: 'Pending approval',
        alternativeLabel_2000: 'Canceled',
      },
      carrier: 'Carrier',
      carrierTracking: 'Tracking',
      shippingTracking: 'Shipping tracking',
      customerEmail: 'Customer email',
      dateOrder: 'Date order',
      externalRef: 'External ref',
      supplierId: 'Supplier id',
      orderId: 'Order ID',
      bdroppyOrderId: 'BDroppy Order ID',
      cost: 'Cost',
      dispatchedTo: 'Dispatched to',
      lastUpdate: 'Last update',
      title: 'Order list',
      warning:
        'WARNING: On November 29th, 2022 from 7 a.m. to 7:30 a.m. (CET) a.m., payments will not be enabled due to extraordinary platform maintenance.',
    },
    new: {
      minOrder400: 'Min order is 400€',
      back: 'Back',
      selectBySku: 'Select the product by SKU',
      cost: 'Cost',
      total: 'Total',
      color: 'Color',
      size: 'Size',
      confirm: 'Confirm',
      quantity: 'Quantity',
      availability: 'Availability',
      add: 'Add',
      shipToCustomer: 'Ship to customer',
      preFill: 'Pre-fill with billing address',
      shipToMe: 'Ship to me',
      shipping: 'Shipping address',
      sameAddress: 'Use the same address for shipping',
      selectEmail: 'Select recipient email',
      productSelected: 'Product selected',
      addNewCustomer: 'Add New Customer',
      newCustomer: {
        email: 'Email',
        edit: 'Edit address',
        new: 'Add new address',
        name: 'Name',
        taxId: 'Tax id',
        sdi: 'SDI',
        cf: 'Fiscal code',
        pec: 'pec',
        companyName: 'Company Name',
        street: 'Street and house number',
        apartment: 'Apartment. suite, etc. (optional)',
        postalCode: 'Postal Code',
        city: 'City',
        province: 'Province',
        country: 'Country',
        prefix: 'Prefix code',
        phone: 'Phone number',
        disableVatNumber: 'Do you want to not receive invoices?',
        cancel: 'Cancel',
        save: 'Save',
        check: 'Verify on VIES',
      },
      recipientSelected: 'Recipient selected',
      selectRecipient: 'Select recipient',
      selectShipping: 'Select your Shipping type',
      freeShipping: 'Free shipping',
      insertNote: 'Insert your note here',
      saveAndPay: 'Save and pay order',
      checkout: 'Checkout',
      nextStep: 'Next step',
      customerInfo: 'Customer info',
      shippingAddress: 'Shipping info',
      productSummary: 'Product summary',
      orderSummary: 'Order summary',
      warning: {
        selectProduct: 'Please first select products',
        selectRecipient: 'Please select recipient',
        selectShipping: 'Please select shipping type',
      },
      weightWarning:
        'The weight of the shipment exceeds the maximum weight that can be shipped to this country, reduce the number of items.',
      messageCompleteOrder:
        'Please select the quantity and size of your product and add it to cart',
      stepbar_1: 'Address',
      stepbar_2: 'Shipping',
      stepbar_3: 'Payment',
      remove: 'Remove',
    },
    edit: {
      cost: 'Cost',
      size: 'Size',
      color: 'Color',
      ecredit: 'Ecredit',
      welcomeDiscount: 'Welcome discount',
      totalToPay: 'Total to pay',
      cashback: 'Cashback',
      vat: 'VAT',
      totalTaxable: 'Total taxable (no tax)',
      productsTaxable: 'Total taxable (no tax)',
      productsTotal: 'Total products',
      total: 'Total',
      quantity: 'Quantity',
      orderDate: 'Order Date',
      shipping: 'Shipping',
      shippingTaxable: 'Shipping',
      shippingTotal: 'Total shipping',
      freeShipping: 'Free shipping',
      ID: 'ID',
      customerInfo: 'Customer info',
      shippingTruck: 'Shipping',
      orderTracking: 'Order tracking',
      saveAndPayLater: 'Save and pay later',
      checkout: 'Checkout',
      edit: 'Edit',
      productSummary: 'Product summary',
      availability: 'Availability',
      messageError: "You can't save an empty order",
      checkoutError: 'The order is empty',
      tabProduct: 'Products',
      tabRecipient: 'Recipient info',
      tabShipping: 'Shipping type',
      tabShipToMe: 'Ship to me',
      tabShipToCustomer: 'Ship to customer',
      empty: 'Cart is empty',
      emptyParagraph: 'Look like you have no items in your order.',
      backToOrder: 'Back to order',
      delete: 'Delete',
      days: 'In working days',
      selectLanguages: 'Select languages',
      minOrder400: 'Min order is 400€',
      updateOrderMessage:
        'Clicking save and pay later or checkout you will update the order with the available quantities',
      toCalculate: 'to calculate',
    },
    detail: {
      cost: 'Cost',
      size: 'Size',
      color: 'Color',
      total: 'Total',
      quantity: 'Quantity',
      ID: 'ID',
      orderDate: 'Order Date',
      customerInfo: 'Customer info',
      shippingTruck: 'Shipping truck',
      orderTracking: 'Order tracking',
      orderSummary: 'Order summary',
      productSummary: 'Product summary',
      recipient: 'Recipient',
      shipping: 'Shipping',
      tabProduct: 'Products',
      tabRecipient: 'Recipient info',
      tabShipping: 'Shipping type',
      tabShipToMe: 'Ship to me',
      tabShipToCustomer: 'Ship to customer',
      days: 'In working days',
    },
    preview: {
      customer: 'Customer info',
      totalTaxable: 'Total taxable (no tax)',
      shipping: 'Shipping',
      vat: 'VAT',
      items: 'Items',
      pc: 'pc',
      cost: 'Cost',
      code: 'Code',
      color: 'Color',
      size: 'Size',
      quantity: 'Quantity',
      total: 'Total',
      ecredit: 'Ecredit',
      payOrder: 'Pay order',
      missing: 'Missing items',
    },
    action: {
      pay: 'Pay order',
      force: 'Force confirm order',
      delete: 'Delete order',
      edit: 'Edit',
      detail: 'See detail',
      return: 'Return request',
      newOrder: 'New order',
    },
    list: {
      ordersSent: 'Orders sent to Rewix',
      ordersError: 'There was an error',
      noData: 'Sorry no data found',
      empty: 'Your order list is empty',
      cta: 'Create your first order',
      createFirstOrder: 'Create your first order',
      freeUser:
        'Do you want to start immediately with your purchases without activating any plan?',
      order400: 'Browse the catalog and place your order (minimum order 400 €)',
      selected: 'selected',
      differentVatRules:
        "You can't pay orders with different vat at the moment.",
      filter: {
        title: 'Filter',
        status: 'Status',
        addToImportList: 'Add to import list',
        addTo: 'Add to',
        shippingCountry: 'Shipping country',
        customerEmail: 'Customer email',
        extRef: 'Ext. Ref.',
        trackingCode: 'Tracking code',
        transRef: 'Trans. Ref.',
        orderId: 'Order id',
        sku: 'Sku',
        applyFilter: 'Apply filters',
        applied: 'Filters applied',
        startDate: 'Start date',
        endDate: 'End date',
        catalogs: 'Catalogs',
        price: 'Price',
        sort: {
          title: 'Sort',
          new: 'Last orders',
          old: 'Older orders',
        },
        product: {
          category: 'Category',
          canale: 'Store Type',
          subCategory: 'Subcategory',
          brands: 'Brands',
          size: 'Size',
          gender: 'Gender',
          season: 'Season',
          availability: 'Availability',
          priceMin: 'Min price',
          priceMax: 'Max price',
          promo: 'Show only product in promo',
          onlyFavourites: 'Show only product on your store',
          priceType: 'Price type',
          promotion: 'Promotions',
          search: 'Search',
          moreFilters: 'More filters',
          onlyOutOfStock: 'Show only products out of stock',
          cta: 'cta',
          filter: 'Filter',
        },
        textSearch: 'Search by customer email',
        reset: 'Reset',
        resetAll: 'Reset all',
      },
      makeReturn: 'You are about to make a return for the order',
      confirmOrder: 'You are about to confirm order',
      sendWithCod: 'Send order with cash on delivery',
    },
    actionbar: {
      filter: 'Filters',
      customerEmail: 'Customer email',
      actions: 'Actions',
      export: 'Export',
      print: 'Print',
      confirm: 'Confirm manually',
      pay: 'Pay',
      selected: 'selected',
    },
    tab: {
      toPay: 'To pay',
      all: 'All',
    },
    update: {
      title: 'Update orders',
      goOrder: 'Go back to order',
      warningMessage:
        'There are some orders that needs your confirmation before payment',
      ordersUpdated:
        'All orders are updated, you are for payment, click proceed to checkout',
      order: 'Order',
      retry: 'Retry',
      confirm: 'Confirm',
      remove: 'Delete',
      checkout: 'Proceed to checkout',
      messageMissing:
        'The following products may have fewer quantities or may no longer be available',
      modalTitleRetry: 'Is again available? ',
      modalSubtitleRetry:
        'If you click on retry will you see if products are again available. If products are no availabe the order will be delete automatically',
      modalTitleConfirm: 'Confirm your order',
      modalSubtitleConfirm:
        "If you click on confirm you will confirm the order as it is now. Order's products availability can be changed, if you want to be sure before confirm click on Retry.",
      modalTitleDelete: 'Are you sure you want to delete your order?',
      modalSubtitleDelete:
        "If you click on remove, your order will change status to 'Canceled' and wil be removed from payement and deleted from your order list",
    },
  },
  ordersReturn: {
    title: 'Return request',
    viewDetail: 'View details',
    list: {
      empty: 'Your return request list is empty',
      emptyCta: 'Go to order',
      info: 'Here you can find your return request and see the status of your request',
      table: {
        dateLabel: 'Request Date',
        orderId: 'Order ID',
        email: 'Customer email',
        status: 'Request status',
        code: 'Return Code',
        file: 'File',
        error: 'Error',
      },
      previewTable: {
        product: 'Product',
        reason: 'Reason',
        file: 'File attached',
      },
      tag: {
        pending: 'Request sent',
        processing: 'Authorized',
        received: 'Received',
        not_received: 'Not received',
      },
      filter: {
        title: 'Filter',
        status: 'Status',
        addToImportList: 'Add to import list',
        addTo: 'Add to',
        shippingCountry: 'Shipping country',
        customerEmail: 'Customer email',
        extRef: 'Ext. Ref.',
        trackingCode: 'Tracking code',
        transRef: 'Trans. Ref.',
        orderId: 'Order id',
        sku: 'Sku',
        applyFilter: 'Apply filters',
        startDate: 'Start date',
        endDate: 'End date',
        catalogs: 'Catalogs',
        search: 'Search',
        sort: {
          title: 'Sort',
          new: 'Last orders',
          old: 'Older orders',
        },
      },
    },
    request: {
      selectSentense: 'Select the products you want for return',
      orderId: 'Order ID',
      size: 'Size',
      sku: 'Sku',
      cost: 'Cost',
      color: 'Color',
      quantity: 'Quantity',
      countLabel: 'Count to return',
      countPlaceholder: 'Count',
      reasonLabel: 'Reason of return',
      reasonPlaceholder: 'Reason',
      noteLabel: 'Note',
      notePlaceholder: 'insert a note',
      imageLabel: 'Image',
      submitRequest: 'Submit request',
      modalTitle: 'Request saved',
      modalSubscription: 'Return request have been submited',
      selectCount: 'Please select count.',
      noProductToReturn: 'There is no product to return.',
      insertNote: 'Please insert note',
      insertNoteAndImage: 'Please insert note and image',
      addQuantity: 'Add quantity',
      delete: 'Delete',
      messageError: 'There is no product to return in this order!',
      reasons: {
        0: 'Other',
        1: 'Bought by mistake',
        2: 'The product is damaged',
        3: 'The product received is not what I requested',
        4: 'The product is malfunctioning',
        5: '',
        6: 'The product is too large / small',
        7: 'I don’t like the product',
        8: 'The product is missing',
      },
    },
    preview: {
      orderInfo: 'Order info',
      id: 'ID',
      orderDate: 'Order date',
      items: 'Item',
      returnRequest: 'Return request',
    },
  },
  payment: {
    title: 'Payment',
    orderQuantity: 'Quantity',
    orderId: 'Order ID',
    products: 'Products',
    cost: 'Item cost',
    toPay: 'To pay',
    showDetail: 'Show detail',
    hideDetail: 'Hide detail',
    catalog: 'Catalog',
    items: 'Items',
    itemsCost: 'Items cost',
    shipping: 'Shipping',
    vat: 'VAT',
    shippingCost: 'Shipping cost',
    recipient: 'Recipient',
    channel: 'Channel',
    product: 'Product',
    securedPayments: 'Payment are secured and encrypted',
    payOrder: 'Pay order',
    confirmOrder: 'Confirm order',
    privacypolicy: 'I’ve read and accept the [privacy]',
    privacy: 'terms and conditions',
    paymentDetail: 'Payment details',
    checkPrivacy: 'Please read and check privacy policy',
    failed: 'Your payment failed. Try again later.',
    payPal: 'Pay with PayPal',
    payPalDescription: 'You will be redirected to PayPal',
    creditCard: 'Pay with credit card',
    cod: 'Cash on delivery',
    codDescription:
      'Spedizione gratuita non applicabile a questa modalità di pagamento ',
    selectType: 'Please select the payment type you want',
    waitingForVerification: 'Your billings informations are in validation.',
    payingOrders: 'You are paying the following order(s)',
    payingOrder: 'You are paying the following order',
    quantitiesMissing:
      'The orders you are trying to pay have some out of stocks products.',
    warningShipToMe:
      'Lowest shipping fee automatically selected because you chose Ship To Me.',
    warningNoAddress:
      'Your order address is not complete, please update it to complete your order',
    warningNoCarrierAvailable:
      'Payment disabled because shipping is not available to your country',
    warningShipmentSize:
      'There is no available carrier for this shipping weight, please go back and modify the carrier',
    differentCarrierOrders:
      'The orders you want to confirm have different couriers. Please modify your selection to proceed',
    warning: 'Warning',
    shipmentSizeCTA: 'Go to my orders',
    completed: {
      title: 'Thank you for your purchase!',
      subtitle: 'Thanks for placing order',
      merchantOrdersFromOneOrder:
        'Your order will be split in the following orders:',
      merchantOrdersFromMultipleOrders:
        'Your orders will be split in the following orders',
      spedition: 'Spedition',
      subtitleMultiple: 'Thanks for placing orders',
      text1: 'We will send you a notification within 5 days when it ships.',
      text2:
        'If you have any question or queries then fell to get in contact us.',
      CTA: 'Go to catalog',
      email:
        'Soon you will receive an email with the invoice of your order attached',
      orderRecap: 'Order recap',
      recapRelative: 'Recap relative to order',
      toPay: 'To be paid on delivery',
      emailCod: 'You will receive an email when order is validated',
      carrier: 'Shipping cost:',
      quantity: 'Quantity:',
      total: 'Total:',
      totalProdoct: 'Total product:',
      discount: 'Discount:',
      cashbackOrder: 'Cashback for this order',
      cashbackCTA: 'Take a look at your cashback amount',
      goTohome: 'back to home',
      taxes: 'Taxes',
      shipping: 'Shipping',
      cashback: 'Cashback',
      share: 'Share',
      detail: 'Detail',
      seeProduct: 'Go to catalogue',
    },
    error: {
      title: 'Error on your purchase!',
      errorPayment: 'Something went wrong with payment',
      notification: 'You will receive a notification of error payment',
      CTA: 'Go to dashboard',
      secondCTA: 'Retry payment',
    },
    authorize: {
      title: 'Authorizing payment',
    },
  },
  payment_plan: {
    orderId: 'Order ID',
    products: 'Products',
    cost: 'Item cost',
    toPay: 'To pay',
    showDetail: 'Show detail',
    hideDetail: 'Hide detail',
    catalog: 'Catalog',
    items: 'Items',
    itemsCost: 'Items cost',
    shipping: 'Shipping',
    vat: 'VAT',
    shippingCost: 'Shipping cost',
    recipient: 'Recipient',
    channel: 'Channel',
    product: 'Product',
    securedPayments: 'Payment are secured and encrypted',
    payOrder: 'Pay order',
    privacypolicy: 'I’ve read and accept the [privacy]',
    privacy: 'terms and conditions',
    checkPrivacy: 'Please read and check privacy policy',
    listName: 'My import list',
    waitingPayment:
      'It seems you have a pending payment. Please retry later or contact our technical support.',
    noCompanyEdit: 'Contact support to modify your billing information',
    paymentDetail: 'Payment details',
    billingAgreementDescription:
      'by activating this payment method, it will be easier to complete your future orders. Remember to read the terms below. Thanks',
    failed: 'Your payment failed. Try again later.',
    completed: {
      title: 'Thank you for your purchase!',
      text1:
        'If you have any question or queries then fell to get in contact us.',
      CTA: 'Go to products',
      createList: 'Create a list',
      bsocial: {
        CTA: 'Start Now',
        whatDoIDo: 'What do I do now?',
        text1: 'Click on the button below and fill in the form',
        text2: 'Browse your list to find a product you like',
        text3:
          'on Facebook, WhatsApp, Telegram and many others to start selling now. Repeat!',
        share: 'Share',
      },
      turnkey: {
        CTA: 'Start Now',
        whatDoIDo: 'What do I do now?',
        text1: 'Click on the button below and fill in the form',
        text2: 'Browse your list to find a product you like',
        text3:
          'on Facebook, WhatsApp, Telegram and many others to start selling now. Repeat!',
      },
    },
    error: {
      title: 'Error on your plan purchase!',
      errorPayment: 'Something went wrong with payment',
      notification: 'You will receive a notification of error payment',
      CTA: 'Go to dashboard',
      secondCTA: 'Retry payment',
    },
    authorize: {
      title: 'Authorizing payment',
    },
    turnkey: {
      title: 'Do you want a turnkey e-commerce too? We’ll take care of it!',
      CTA: 'Discover more',
    },
    yourRecap: 'Your purchase',
    subtitle: 'Do you already have a list?',
    email:
      'Soon you will receive an email with the invoice of your order attached',
    browseCatalog:
      'Browse the product catalog and choose which ones to add to your list, create your markup rules and select on which one channel start selling',
    payment: 'Payment:',
    plan: 'Plan:',
    expire: 'Scadenza:',
    service: 'Service:',
  },
  payment_support_gold: {
    orderId: 'Order ID',
    products: 'Products',
    cost: 'Item cost',
    toPay: 'To pay',
    showDetail: 'Show detail',
    hideDetail: 'Hide detail',
    catalog: 'Catalog',
    items: 'Items',
    itemsCost: 'Items cost',
    shipping: 'Shipping',
    vat: 'VAT',
    shippingCost: 'Shipping cost',
    recipient: 'Recipient',
    channel: 'Channel',
    product: 'Product',
    securedPayments: 'Payment are secured and encrypted',
    payOrder: 'Pay order',
    privacypolicy: 'I’ve read and accept [privacy]',
    privacy: 'privacy policy',
    checkPrivacy: 'Please read and check privacy policy',
    paymentDetail: 'Payment details',
    failed: 'Your payment failed. Try again later.',
    completed: {
      title: 'Thank you for your purchase!',
      text1:
        'If you have any question or queries then fell to get in contact us.',
      CTA: 'Next',
    },
    error: {
      title: 'Error on your plan purchase!',
      errorPayment: 'Something went wrong with payment',
      notification: 'You will receive a notification of error payment',
      CTA: 'Go to dashboard',
      secondCTA: 'Retry payment',
    },
    authorize: {
      title: 'Authorizing payment',
    },
  },
  profile: {
    submenu: {
      user: 'User',
      profile: 'Profile',
      referral: 'Referral',
      billing: 'Invoice',
      address: 'Address',
      ecredit: 'Ecredit',
      logout: 'Logout',
      backAdmin: 'Go back as admin',
      technicalSupport: 'Technical support',
      mode: 'Mode',
      selectLang: 'Language',
    },
    title: {
      title: 'Profile',
    },
    tab: {
      general: 'General',
      ecredit: 'Ecredit',
      shipping: 'Shipping',
      password: 'Password',
      affiliation: 'Affiliation',
      invoice: 'Invoice',
    },
    plan: {
      title: 'Your plan',
      empty: 'Start your business',
      expire: 'Expired date',
      noplan: 'no plan selected',
      btn: 'Choose your plan',
      cta: 'Upgrade your plan',
      unsubscribe: 'Cancel subscription',
      unsubscribeTitle: 'Are you sure you want to unsubscribe?',
      confirm: 'Confirm',
      cancel: 'Cancel',
      maxProducts: 'Product limit',
      whatIncludes: "Cos'è incluso",
    },
    user: {
      name: 'Name',
      mail: 'Email',
      role: 'Role',
      expire: 'Expired date',
      title: 'User info',
      empty: 'free',
    },
    list: {
      title: 'Your list',
      channel: 'Channel',
      empty: 'Create your first list!',
      cta: 'Create list',
      product: 'products',
      otherList: 'Create another list',
      noChannel: 'No channel',
    },
    password: {
      control: 'Password must be minimum 6+',
      equal: 'Password and confirm password does not match',
      success: 'Password changed successfully',
      old: 'Insert your old password',
      changePassword: 'Change password',
      newPassword: 'New password',
      insertPassword: 'Insert new password',
      subtitle: 'Please check your email and confirm new password',
    },
    address: {
      title: 'Billing address',
      shipping: 'Shipping address',
      btn: 'Edit',
      modalTitle: 'Confirm delete address',
      modalDescription: 'Are you sure you want to delete address?',
      confirm: 'Confirm',
      addressSaved: 'Address saved successfully',
      addressUpdated: 'Address updated successfully',
      addressDeleted: 'Address deleted successfully',
      validVat: 'Your vat is valid',
      invalidVat: 'Invalid vat',
    },
    invoice: {
      title: 'Invoice history',
      empty: 'No invoice found',
      date: 'Date order',
      cost: 'Cost',
      code: 'Code',
      plan: 'Plan',
      type: 'Type',
      Document: 'Document',
      noInvoice:
        'Here you can find and download your invoice.There are no invoice for the moment.',
      month: 'Month',
      year: 'Year',
    },
    ecredit: {
      wallet: 'YOUR WALLET',
      return: 'Return',
      transaction: 'Transaction',
      noEcredit:
        'Here you can find your ecredit. You dont have any order for the moment',
      amount: 'Amount',
      maxAmount: 'Max 100 Euro',
      iban: 'Iban',
      accountHolder: 'Account holder',
      CTA: 'Invia richiesta',
      withdrawTitle: 'Richiesta di addebito',
      withdrawError: 'Error!',
      withdrawSuccess: 'Success!',
      withdraw: 'Withdraw',
      returnTitle: 'Return',
      orderDate: 'Order date',
      orderId: 'Order number',
      actions: 'Document',
      type: 'Type',
      return_order: 'Return',
      cashback_products: 'Cashback',
      signup_credit: 'Signup credit',
      signup_credit_expired: 'Signup credit expired',
      payment: 'Payment',
      credit: 'Credit',
      referral: 'Promocode',
      credit_referral_products: 'Referral products',
      info: "You haven't yet reached the €100 threshold to request the transfer",
      total: 'TOTAL',
    },
    referral: {
      titleTab: 'YOUR FRIENDS',
      tabSubtitle:
        'Find friends who have purchased at least one product in the list below. Continue sharing with them and others to accumulate more and more cashback.',
      title: 'Share and earn',
      invite:
        'Share our products with a friend. You both earn! [10%] for him and [10%] for you for 12 months',
      affiliatedEarn:
        'He receives a [number] welcome for registering on BDroppy',
      copy: 'Copy link',
      copied: 'Copied',
      revenue: 'Revenue',
      products: 'Products',
      service: 'Services',
      active: 'Active',
      subscriptionDate: 'Subscription date',
      expired: 'Expired',
      invited: 'Invited',
      noUser: 'No user',
      daysLimit:
        'You have [number] days from your registration date to share the link',
      faq: {
        question_1: 'Who can join',
        answer_1:
          'BDroppy’s Affiliate Programme is aimed at anyone who wants to find an alternative, easy-to-set-up, flexible and free source of income: online marketing enthusiasts, entrepreneurs, influencers, youtubers, content creators, freelancers',
        question_2: 'How to collect your commissions',
        answer_2:
          'On BDroppy, you can access your dedicated section at any time, where you can see the total of your commissions. You can decide whether to use them to make your purchases on BDroppy or to request a transfer to have your earnings directly into your bank account.',
        question_3: 'How do I monitor my referrals and commissions?',
        answer_3:
          'On BDroppy, you will have a special section where you can monitor your commissions, the people you have sent your link to, activated registrations and expired registrations.',
      },
    },
  },
  channel: {
    list: {
      createList: 'Create list',
      products: 'Products',
      addProducts: 'Add products',
      edit: 'Edit',
      currency: 'Currency',
      dropshippingShipments: 'Shipments',
      markup: 'Markup',
      language: 'Language',
      status: 'Status',
      shipToMe: 'Ship to me',
      shipToCustomer: 'Ship to customer',
      empty: 'Your import list is empty, create your first list',
      addToWishlist: 'Add product to wishlist',
      removeFromWishlist: 'Remove product from wishlist',
      cta: 'cta',
    },
    new: {
      comingSoon: 'COMING SOON',
      turnkey: 'Turnkey webstore',
      saveAndClose: 'Save and close',
      selectChannel: 'Choose channel',
      activateChannel: 'Activate channel',
      listName: 'List name',
      currency: 'Currency',
      language: 'Language',
      choose: 'Choose your channel',
      needPlan: 'You need to buy a plan in order to activate a channel',
      selectProduct: 'Select product',
      activateChannelInfo:
        "You can't activate any channel because you are free user. In order to activate channel/s you need to buy a plan",
      stepSelectChannel: '2 - Select Channel',
      stepManageSetting: '1 - Manage your list',
      activatePlan: 'Activate a plan',
      cantActivate: "You can't activate any channel, first need to buy a plan",
      cantActivateTurnkey:
        "You can't activate turnkey, you need a plan that allows activation of turnkey webstore (Easy, Professional or Enterprise)",
    },
    edit: {
      productList: 'Product list',
      downloadFile: 'Download file',
      modalTitle: 'Download catalog file',
      modalSubTitle: 'Select language and format of the file',
      modalCta: 'Download',
      modalCta2: 'Share it',
      settings: 'Settings',
      changeLang: 'Select language of product description',
      selectLanguages: 'Select languages',
      selectFormat: 'Select format',
      channelName: 'Channel',
      activateChannel: 'Activate channel',
      emptyList: 'Your list is empty',
      emptyListSubLabel: 'Add products and start your business',
      emptyListDeleted: 'Your list is deleted',
      emptyListDeletedSub: 'you need to buy a plan in order to...',
      noProductFound: 'Ops no product found',
      addProducts: 'Add products',
      deleteProducts: 'Delete products',
      removeProduct: 'Delete',
      editProduct: 'Edit',
      productSelected: ' products',
      selected: 'Selected',
      selectProduct: 'Select product',
      removeProducts: 'Remove product',
      pageSelectedProduct: 'All [products] on this page are selected',
      selectAllProduct: 'Select all the products on the catalog',
      selectAllProductMobile: 'Add all products',
      linkCopied: 'Link copied',
      disableAutoImport:
        'To make changes on your list you need to deactivate automatic import setting.',
      here: 'HERE.',
      channel: {
        channelConnected: 'Channel connected',
        channelNotConnected:
          'Connection error. Your Amazon Seller account is not actually active or a valid payment method is not connected.\n' +
          'Please contact Amazon to receive further info.',
        alertEbay:
          'Attention: it takes up to 4 hours to start viewing your products online',
        title: 'Turnkey site',
        successConnection: 'Richiesta inviata',
        deleteChannel: 'Delete channel',
        shopifyTemplate: 'Shopify platform has only one selectable template',
        disconnectChannel: 'Disconnect channel',
        save: 'Save',
        upgradePlan: 'Upgrade plan',
        close: 'Close',
        confirm: 'Confirm',
        buyNow: 'Buy now',
        turnkeyRegisterExpl: 'Complimenti per la tua scelta!',
        turnkeyRegisterExplSubtitle1:
          'Ti ricordiamo che per mettere online il tuo sito Shopify, dovrai attivare, anche dopo la consegna, un piano Shopify. Clicca [QUI] per trovare il piano più adatto alle tue esigenze.',
        turnkeyRegisterExplHere: 'QUI',
        turnkeyRegisterExplSubtitle2:
          'Ricordati di compilare i campi qui sotto e scegliere 1 lingua e 1 valuta, tra quelle disponibili, per il tuo sito.',
        registerTitle: 'Do you want to register a new domain?',
        registerSubtitle: 'Do you want to register a new domain?',
        selectDataTitle: 'Please select currency and language ',
        selectDataTitleWoocommerce:
          'You can select one language and currency for your website',
        selectDataTitlePrestashop:
          'You can select three languages and three currencies for your website',
        selectPlatform: 'Please select platform',
        selectPlatformPlaceholder: 'Choose platform',
        selectPlatformLabel: 'Select platform',
        selectPlatformTitleWoocommerce:
          'Choose the platform you prefer for your website',
        radio1: 'Yes, thanks',
        radio2: 'No, I already have a domain',
        domainTitle: 'Insert your domain',
        domainPlaceholder: 'domain.com',
        domainDescriptionYes1:
          'Our offer includes a free .com or .business domain.',
        domainDescriptionYes2:
          'If you want to register another extension or you already own a\n' +
          '              domain, select &apos;No, i already have a domain&apos;.',
        domainDescriptionNo1:
          'To use this domain you need to be able to access its control panel\n' +
          '              to change the DNS zone.',
        domainDescriptionNo2:
          'After completing the form you will receive an email with all the\n' +
          '              information to direct your domain to our servers.',
        siteLanguage: 'Site language',
        siteLanguagePlaceholder: 'Select language',
        siteCurrency: 'Site currency',
        siteCurrencyPlaceholder: 'Site currency',
        template: 'Choose template',
        templateButton: 'Select template',
        preview: 'Preview',
        saveSettings: 'Save settings',
        connectChannel: 'Connect channel',
        connectToEbay: 'Connect to Ebay',
        connectToAmazon: 'Connect to Amazon',
        changeChannel: 'Change channel',
        goBack: 'Go back',
        search: 'Search',
        chooseTemplate: 'Choose template',
        chooseTemplatePrestashop: 'Choose one Prestashop template',
        chooseTemplateWoocommerce: 'Choose one Woocommerce template',
        chooseTemplateEasy: 'Choose basic template from Woocommerce or Shopify',
        noDomain: 'Fill in the Domain field first',
        domainAvailable: 'Available',
        domainUnavailable: 'Unavailable',
        domainSelected: 'Domain selected',
        selected: 'Selected',
        howToConnectAmazon: 'How to connect your Amazon account to BDroppy',
        howToConnectEbay: 'How to connect you Ebay account to BDroppy',
        selectCountryAmazon:
          'Select the country of your market, go to Amazon Seller Central and authorize BDroppy as a new developer',
        selectCountryEbay:
          'Select the country of your market and insert you Ebay username',
        amazonSeller:
          'Enter your Seller ID and your Mws Auth Token you receive from Amazon',
        ebaySeller:
          'Allow the sharing of your data with TARS, create shipping, return and payment policy on Ebay',
        paymentPolicy: 'Payment policy',
        fullfillmentPolicy: 'Fullfillment policy',
        returnPolicy: 'Return policy',
        countryEbay: 'Ebay market country',
        countryAmazon: 'Amazon market country',
        selectCountry: 'Select market country',
        ebayUsername: 'Ebay Username',
        myEbayUsername: 'My Ebay Username',
        amazonSellerID: 'Seller ID',
        authToken: 'Mws Auth Token',
        automaticUpdate:
          'Disable this option if you want to deactivate automatic update',
        automaticPrice: 'Automatic update price',
        statusChannel: 'Status channel',
        logs: 'See logs',
        connection: 'Check connection to channel',
        connect1: 'How to connect your store to BDroppy',
        prestaShopConnect2: 'Install the BDroppy module from',
        woocommerceConnect2: 'Install the BDroppy plugin from',
        prestaShopConnect3: 'Activate the module in your module page',
        woocommerceConnect3: 'Activate the plugin in your plugins page',
        prestaShopConnect4: 'Go to Prestashop > Dashboard > BDroppy',
        woocommerceConnect4: 'Go to WordPress > Dashboard > BDroppy',
        downloadLatestVersion: 'You can donwload the latest version of plugin',
        connect5: 'Login from plugin with your email and BDroppy password',
        connect6: 'Having troubles?',
        contattaci: 'Contact us here',
        qui: 'here',
        webUrl: 'Your website URL',
        ssDescription:
          'The integration does not support changes made on Squarespace. For all product changes such as price updates, inventory and channel connection, go to your dashboard on Bdropppy',
        imageOrientation: 'Product Image Orientation',
        selectImageOrientation: 'Select image orientation',
        selectImageOrientationSub:
          'Select the orientation of the image in the website.',
        storeName: 'Store name:',
        dashboardLink: 'Shopify dashboard link:',
        ADMIN_DASHBOARD: 'Dashboard',
        storeNameTitle: 'Store name',
        payPalTitle: 'Paypal email',
        ecreditInfo:
          'You have selected to receive your money as a credit into your purse. You can request the transfer of your earnings to your bank upon reaching 100€.',
        payPalDescription:
          'Insert your email of paypal account in order to activate paypal payment',
        confirmationEmail: 'Confirmation Email',
        paypalEmail: 'PayPal email',
        socialStoreName: 'Store name',
        storeNameDescription:
          'Il nome del negozio apparirà nel link di atterraggio dei tuoi prodotti store.mybsocial.com',
        products: 'PRODUCTS',
        orders: 'ORDERS',
        statusConnection: 'Connection status:',
        lastUpdated: 'Last product updated',
        lastImported: 'Last product imported',
        productErrors: 'Products with errors',
        connected: 'Connected',
        disconnected: 'Disconnected',
        statusNotOk: 'Please fix connection using following',
        errorWix:
          'Warning, be sure that your application has Wix Store application installed',
        errorSquarespace:
          'Warning, Store pages are required for creating products in Squarespace and must be created by the merchant.',
        notPay:
          'You need to buy a plan in order to activate channel and update product on your website',
        modalTitle: 'Are you sure you want to disconnect channel?',
        modalSubtitle: 'Products removed on catalog message',
        congratulation: 'Congratulations',
        isConnected: 'is now connected!',
        helpPdf: 'Help PDF',
        titleHelpPdf: 'Here you can find a tutorial to connect channel',
        ebayToken:
          'Ebay disconnected, please check the username and then connect again',
        amazonToken: 'Amazon disconnected, please login again to Amazon',
        error: 'Error',
        integrationError:
          'Integration still being deactivated. Please wait 15 minutes before trying again',
        selectedDomain: 'Domain',
        selectedLanguage: 'Language',
        selectedCurrency: 'Currency',
        selectedTemplate: 'Template',
        selectedPlatform: 'Platform',
        selectTemplate: 'Please select a template',
        selectLanguage: 'Please select language and currency',
        selectLanguageAndCurrency:
          'Here you can customize language and currency of your list',
        descriptionSquarespace:
          'Thanks to BDroppy, you can have your Squarespace site configured with our fashion catalog integrated. Through the plugin, all data (products, prices and orders) will be automatically synchronized.',
        descriptionEbay:
          'With BDroppy you can sell our fashion catalog online on eBay and make money thanks to our dropshipping service: you will buy our products at a wholesale price and resell them at the best price to your customers',
        descriptionPrestashop:
          'Thanks to BDroppy, you can have your Prestashop site configured with our fashion catalog integrated. Through the plugin, all data (products, prices and orders) will be automatically synchronized.',
        descriptionAmazon:
          'With BDroppy you can integrate our fashion catalog into your Amazon store, with the dropshipping service included, to resell thousands of original designer fashion products online',
        descriptionTurnkey:
          'We create your online store on Woocommerce or Prestashop, with a pre-integrated fashion catalog. You’ll have your e-commerce platform ready to start selling and earning money right away!',
        descriptionWix:
          'Thanks to BDroppy, you can have your Wix site configured with our fashion catalog integrated. Through the plugin, all data (products, prices and orders) will be automatically synchronized.',
        descriptionWoocommerce:
          'Thanks to BDroppy, you can have your Woocommerce site configured with our fashion catalog integrated. Through the plugin, all data (products, prices and orders) will be automatically synchronized.',
        descriptionEcwid: 'Ecwid placeholder description',
        descriptionSocialEcommerce: 'Social Ecommerce placeholder description',
        faq: 'Faq',
        wixDescription:
          'Dear customer, to activate the channel you will be redirected to the wizard',
        faqSubtitle: 'Most common questions',
        needHelp: 'Do you need help?',
        needHelpSubtitle: 'do you need help subtitle',
        contactUs: 'Contact us',
        marketplaceTitle: 'Ecommerce e Marketplace Integrati',
        marketplaceDescription:
          'BDroppy si integra con le migliori piattaforme di e-commerce e marketplace per far crescere il tuo business in dropshipping.',
        bSocialDescription:
          'Vendi sui tuoi social network preferiti, in pochi click e senza bisogno di un’e-commerce. Condividi con la tua community, vendi, guadagna',
        turnkeyDescription:
          'Affidati al nostro team di esperti per una scelta professionale: creeremo per te un e-commerce personalizzato, integrato con il nostro servizio dropshipping.',
        turnkeyTitle: 'Sito Chiavi In Mano',
        prestashopInfo: 'Compatible with all versions 1.7',
        ebay: {
          faq: {
            title: 'Most common questions',
            question_1:
              'Do I have to sell the same products in-store as I do online?',
            answer_1:
              'No, you can choose exactly what products to sell online, in-store, or both.',
            question_2:
              'Do I have to sell the same products in-store as I do online?',
            answer_2:
              'No, you can choose exactly what products to sell online, in-store, or both.',
            question_3:
              'Do I have to sell the same products in-store as I do online?',
            answer_3:
              'No, you can choose exactly what products to sell online, in-store, or both.',
            question_4:
              'Do I have to sell the same products in-store as I do online?',
            answer_4:
              'No, you can choose exactly what products to sell online, in-store, or both.',
          },
        },
        wix: {
          startSelling: 'Start selling',
          startSellingDescription:
            'Sell your product directly from your website',
          activateChannel: 'Connect channel',
          activateDescription: 'You will be redirect on Wix',
          waitConnection: 'Wait a few minutes',
          waitConnectionDescription: 'wait the sync of product',
          review: {
            title: 'Condividi la tua esperienza',
            subTitle:
              'Aiutaci a migliorare BDroppy - Dropshipping. Ti invitiamo a condividere la tua opinione su di noi.',
            cta: 'Click here to leave a review',
          },
          faq: {
            title: 'Most common questions',
            question_1:
              'Do I have to sell the same products in-store as I do online?',
            answer_1:
              'No, you can choose exactly what products to sell online, in-store, or both.',
            question_2:
              'Do I have to sell the same products in-store as I do online?',
            answer_2:
              'No, you can choose exactly what products to sell online, in-store, or both.',
            question_3:
              'Do I have to sell the same products in-store as I do online?',
            answer_3:
              'No, you can choose exactly what products to sell online, in-store, or both.',
            question_4:
              'Do I have to sell the same products in-store as I do online?',
            answer_4:
              'No, you can choose exactly what products to sell online, in-store, or both.',
          },
        },
        amazon: {
          faq: {
            title: 'Most common questions',
            question_1:
              'Do I have to sell the same products in-store as I do online?',
            answer_1:
              'No, you can choose exactly what products to sell online, in-store, or both.',
            question_2:
              'Do I have to sell the same products in-store as I do online?',
            answer_2:
              'No, you can choose exactly what products to sell online, in-store, or both.',
            question_3:
              'Do I have to sell the same products in-store as I do online?',
            answer_3:
              'No, you can choose exactly what products to sell online, in-store, or both.',
            question_4:
              'Do I have to sell the same products in-store as I do online?',
            answer_4:
              'No, you can choose exactly what products to sell online, in-store, or both.',
          },
        },
        turnkey: {
          faq: {
            title: 'Most common questions',
            question_1:
              'Do I have to sell the same products in-store as I do online?',
            answer_1:
              'No, you can choose exactly what products to sell online, in-store, or both.',
            question_2:
              'Do I have to sell the same products in-store as I do online?',
            answer_2:
              'No, you can choose exactly what products to sell online, in-store, or both.',
            question_3:
              'Do I have to sell the same products in-store as I do online?',
            answer_3:
              'No, you can choose exactly what products to sell online, in-store, or both.',
            question_4:
              'Do I have to sell the same products in-store as I do online?',
            answer_4:
              'No, you can choose exactly what products to sell online, in-store, or both.',
          },
        },
        return: {
          faq: {
            title: 'Most common questions',
            question_1:
              'Do I have to sell the same products in-store as I do online?',
            answer_1:
              'No, you can choose exactly what products to sell online, in-store, or both.',
            question_2:
              'Do I have to sell the same products in-store as I do online?',
            answer_2:
              'No, you can choose exactly what products to sell online, in-store, or both.',
            question_3:
              'Do I have to sell the same products in-store as I do online?',
            answer_3:
              'No, you can choose exactly what products to sell online, in-store, or both.',
            question_4:
              'Do I have to sell the same products in-store as I do online?',
            answer_4:
              'No, you can choose exactly what products to sell online, in-store, or both.',
          },
        },
        ecwid: {
          startSelling: 'Start selling',
          startSellingDescription:
            'Sell your product directly from your website',
          activateChannel: 'Connect channel',
          activateDescription: 'You will be redirect on Ecwid',
          waitConnection: 'Wait a few minutes',
          waitConnectionDescription: 'wait the sync of product',
        },
        ekm: {
          startSelling: 'Start selling',
          startSellingDescription:
            'Sell your products directly from your website',
          activateChannel: 'Connect channel',
          activateDescription: 'You will be redirect on Ekm',
          waitConnection: 'Wait a few minutes',
          waitConnectionDescription: 'wait the sync of product',
        },
        woocommerce: {
          startSelling: 'Start selling',
          startSellingDescription:
            'Sell your products directly from your website',
          activateChannel: 'Connect channel',
          activateDescription: 'You will be redirect on Woocommerce',
          waitConnection: 'Wait a few minutes',
          waitConnectionDescription: 'wait the sync of product',
          shopUrl: 'Shop url',
          importAsPublished: 'Import as published',
          shopDescription: 'Shop url ',
        },
        shopify: {
          startSelling: 'Start selling',
          startSellingDescription:
            'Sell your products directly from your website',
          activateChannel: 'Connect channel',
          activateDescription: 'You will be redirect on Shopify',
          waitConnection: 'Wait a few minutes',
          waitConnectionDescription: 'wait the sync of product',
          waitConnection24h:
            'The app will be installed within the next 48 working hours',
          shopUrl: 'Shop URL',
          shopDescription: 'Shop url ',
          help: 'help',
          contactUs: 'Contact us',
          alert:
            'Please insert just the name of shop without https:// or myshopify.com',
          active: 'Your Shopify store is connected',
          admin:
            "Per cambiare messaggio visualizzato dall'utente metter su Active lo switch. Dopo aver cambiato clicca sul pulsante Salva. Per eliminare il canale clicca sull'icona del cestino e clicca conferma nel modal.",
          submit: 'Submit',
          save: 'Save',
          excludeFromUpdate: 'Exclude from update',
          excludeFromUpdateSubtitle:
            'Select what you want to exclude from your update. ',
          price: 'Price',
          description: 'Description',
          tags: 'Tags',
          sku: 'Sku',
          importAsPublishedTitle: 'Import product as published',
          importAsPublishedTitleSubtitle:
            'Import product directly as published instead of draft',
          archiveMissingItems: 'Archive items',
          archiveMissingItemsTitle:
            'Archive items when out of stock or deleted',
          archiveMissingItemsTitleSubtitle:
            'Archive product on shopify when is out of stock or deleted from your list',
        },
        squarespace: {
          selectImageOrientationTitle: 'Image orientation',
          selectImageOrientation:
            'Select the orientation of the image in the website.',
          startSelling: 'Start selling',
          startSellingDescription:
            'Sell your product directly from your website',
          activateChannel: 'Connect channel',
          activateDescription: 'You will be redirect on Squarespace',
          waitConnection: 'Wait a few minutes',
          waitConnectionDescription: 'wait the sync of product',
          faq: {
            title: 'Most common questions',
            question_1:
              'Do I have to sell the same products in-store as I do online?',
            answer_1:
              'No, you can choose exactly what products to sell online, in-store, or both.',
            question_2:
              'Do I have to sell the same products in-store as I do online?',
            answer_2:
              'No, you can choose exactly what products to sell online, in-store, or both.',
            question_3:
              'Do I have to sell the same products in-store as I do online?',
            answer_3:
              'No, you can choose exactly what products to sell online, in-store, or both.',
            question_4:
              'Do I have to sell the same products in-store as I do online?',
            answer_4:
              'No, you can choose exactly what products to sell online, in-store, or both.',
          },
        },
      },
    },
    settings: {
      general: {
        title: 'Settings',
        listName: 'List name',
        currency: 'Currency',
        language: 'Language',
        generalSetting: 'General setting',
        generalSettingSubtitle:
          'Manage settings of your list name, currency and language ',
        save: 'Save',
        deleteTitle: 'Delete rules',
        deleteSubtitle: 'Are you sure you want to delete rules?',
        deleteSubtitleConfirm:
          'If you click on confirm all the rules will be deleted, are you sure you want to delete?',
        deleteAll:
          'If you decide to update the catalog automatically the query rules will be deleted',
        cancel: 'Cancel',
        confirm: 'Confirm',
        saveSuccess: 'You have updated your list successfully.',
        saveError: 'Select one or more product types to save the changes',
        ruleName: 'Rule name',
        minQuantity: 'Min quantity',
        confirmSavedChanges: 'Changes that you made may not be saved.',
      },
      markup: {
        infoCatalogName:
          'Give a name to your product list and create your own catalog.',
        infoMarkUp: 'Choose on which base price to apply your markup settings.',
        infoRounding: 'Choose how to round off your selling prices.',
        markupSettings: 'Markup settings',
        socialEcommerce:
          'Markup settings are disabled for social ecommerce users',
        markupSettingsInfo:
          'Customize your profit setting. You can add different markups and apply them to different product categories.',
        baseCost: 'Base cost',
        rounding: 'Rounding',
        markupPer: 'Markup%',
        userTaxPer: 'User tax %',
        addMoreMarkupRules: 'Add more markup rules',
        name: 'Name',
        rules: 'Rules',
        newRule: 'New rule',
        applyTo: 'Apply to',
        applyToInfo:
          'To whole catalog will follow the main markup rule unless you pick specific categories to apply the markup',
        selectFilter: 'Select filter',
        language: 'Language',
        pricings: {
          0: 'None',
          streetPrice: 'Street price',
          bestTaxable: 'Cost (no VAT)',
          suggestedPrice: 'Suggested price',
        },
        roundings: {
          no: 'No rounding (es. 23.65)',
          xxx_00: 'Round to xxx.00 (es. 24.00)',
          xxx_90: 'Round to xxx.90 (es. 23.90)',
          xxx_99: 'Round to xxx.99 (es. 23.99)',
          xx9_00: 'Round to xx9.00 (es. 29.00)',
          xx9_99: 'Round to xx9.99 (es. 29.99)',
          xx900: 'Round to xx900 (es. 2900)',
          xx990: 'Round to xx990 (es. 2990)',
          xx000: 'Round to xx000 (es. 2000)',
          xx9000: 'Round to xx9000 (es. 29000)',
          xx9900: 'Round to xx9900 (es. 29900)',
          xx0000: 'Round to xx0000 (es. 20000)',
        },
        cancel: 'Cancel',
        save: 'Save',
      },
      query: {
        addMoreQueryRules: 'Add more query rules',
      },
      upload: {
        automaticArrivals: 'Automatic arrivals uploads',
        manualSelection: 'Manual selection',
        allNewProducts: 'All new products published',
        automaticArrivalsInfo1:
          'Select the default settings to upload new arrivals.',
        automaticArrivalsInfo2:
          'Enable this option if you want the goods shipped to you and not to your end customer.',
        shipToMe: 'Ship to me',
        noShippingAddress: "Looks like you don't have a shipping address.",
        addShippingAddress: 'Add a shipping address',
        shipToCustomer: 'Ship to customer',
        newArrivalsUpload: 'New arrivals uploads',
        advancedSettings: 'Advanced settings',
        shippingSettings: 'Shipping',
        addFilters: 'Set rules with filters',
        useMinQuantity: 'Set min quantity',
        useMinQuantityInfo:
          'Products with quantities below this threshold will be hidden from your list.',
        importRules: 'Set import rules',
        importRulesSubtitle:
          'Enable this option to import products using advanced filters.',
        info: 'info test for upload',
        minQuantityDescription:
          "Select this option if you don't want to import products with low quantities",
        limitProduct:
          'Automatic upload is not available because your plan has limit number of products',
      },
      applyTo: {
        list: {
          canale: 'Store type',
          category: 'Category',
          subcategory: 'Sub category',
          brand: 'Brand',
          gender: 'Gender',
          season: 'Season',
          bestTaxable: 'Cost',
          streetPrice: 'Street price',
          suggestedPrice: 'Suggested price',
        },
        genders: {
          kids: 'Kids',
          boy: 'Boy',
          girl: 'Girl',
          women: 'Women',
          unisex: 'Unisex',
          men: 'Men',
        },
        seasons: {
          fw: 'Fall / Winter',
          ss: 'Spring / Summer',
          'all-year': 'All year',
        },
        bestTaxables: {
          '=': 'Equal',
          '<>': 'Not equal',
          '>': 'Greater than',
          '>=': 'Greater than equal',
          '<': 'Less than',
          '<=': 'Less than equal',
          value: 'Value',
        },
      },
    },
  },
  products: {
    list: {
      confirm: 'Confirm',
      shareCTA: 'Share',
      share: "Look what I've just picked up for you!",
      shareStore: 'Look at my store!',
      shareSubtitle: 'Check this out on BDroppy!',
      titleFree:
        'Attiva subito un piano e inizia a vendere migliaia di prodotti moda firamta in modo automatico',
      subTitleFree:
        'Psss! Sai che puoi effettuare fino a 5 ordini manuali al mese senza costi di servizio? ',
      titleFreeCta: 'Choose a plan',
      titleFree2:
        'Oppure puoi effettuare fino a 5 ordini al mese e provare tutta la qualità dei nostri prodotti e del nostro servizio logistico distributivo, senza costi aggiuntivi',
      titleFreeCta2: 'Seleziona i prodotti',
      highlitedBrand: 'In evidenza',
      about1: 'Leader in fashion E-COMMERCE for 12 years',
      about2: 'ORIGINAL FASHION BRANDS',
      about3: 'SHIPMENTS PER YEAR',
      cartDescription:
        'Up to 5 manual orders per month included, purchases at wholesale prices, no service costs!',
      titleModal: 'Product details',
      titleModalError: 'Error detail',
      titleModalCountry: 'Select country for shipping',
      titleModalCurrency: 'Select currency',
      selectProduct: 'Select product',
      selectCountry: 'Select country',
      popular: 'Popular',
      removeProduct: 'Remove product',
      productSelected: 'selected',
      pageSelectedProduct: 'All [products] on this page are selected',
      selectAllProduct: 'Select all the products on the catalog',
      limitOrder: 'You can select max 10 products',
      finishOrder: 'Add product to cart and finish the order',
      searchProduct: 'Search by product',
      addToList: 'Add to list',
      addToCart: 'Add to cart',
      modalTitle: 'Add to your list',
      modalPlaceholder: 'Select your catalog',
      product: 'product',
      catalog: 'added to your catalog:',
      firstList: 'Create your first list',
      anotherList: 'Create your list',
      delete: 'Delete',
      profit: 'Profit',
      changeLang: 'Select language of product description',
      changeCountry: 'Select shipping country',
      changeCurrency: 'Select currency',
      currency: 'Currency',
      country: 'Country',
      language: 'Language',
      cost: 'Cost',
      sellPrice: 'Sell price',
      viewDetail: 'View detail',
      availability: 'Availability',
      availabilityLessThan5: 'Ultimi pezzi rimasti',
      outOfStock: 'Out of stock',
      rule: 'Rule',
      size: 'Size',
      retail: 'Retail',
      cashback: 'Cashback',
      suggestedPrice: 'Suggested price',
      suggested: 'Suggested',
      shippingCost: 'Shipping cost',
      shippingCostFrom: 'from',
      shippingFees: 'See all shipping fees',
      shippingFeesDelay: 'Delivery time can be longer than expected',
      partner: 'Partner stock product',
      info: "This shipment may require a few extra days of preparation, thus prolonging the delivery time stated in the 'Shipping costs' table",
      selectLanguage: 'Select description language',
      selectLanguageAndCurrency:
        'Here you can customize language and currency of your list',
      limit100products:
        'You have reached the limit of 100 products on your catalog',
      limit1000products:
        'You have reached the limit of 1000 products on your catalog',
      queryRulesActive:
        'You have query rules activated on your catalog setting, deactivate it to add products manually',
      automaticUpdate:
        'You have automatic update on your list, deactivate it to add products manually',
      modelId: 'Model Id',
      productAddedStore: 'Product added to store',
      productRemovedStore: 'Product removed from store',
      productMaxLimit: 'Limit of products reached',
      quantity: 'Quantity',
      message: 'Message',
      extradiscount: 'Extra discount',
      sellAt: 'Sell at',
      esclIVA: 'escl IVA',
      header: {
        title_1: 'Authentic products only',
        title_2: 'Wholesale prices',
        title_3: 'Shipping from Italy',
      },
      filter: {
        new: 'New arrivals',
        old: 'Older arrivals',
        brandsAZ: 'Brands A-Z',
        brandsZA: 'Brands Z-A',
        title: 'sort',
      },
      tag: {
        shoes: 'Shoes',
        bags: 'Bags',
        watch: 'Watch',
        jeans: 'Jeans',
        sunglasses: 'Sunglasses',
      },
      billingAddressIncomplete: {
        title: 'Billing address is incomplete',
        description:
          'Your billing address is incomplete, please fill all the fields in your profile.',
        goTo: 'Go to edit',
      },
    },
    edit: {
      editProduct: 'Edit product',
      tag: 'Tag',
      save: 'Save',
      disableOptions:
        'Disable this option if you want to unpublish product on your channel',
      publishProduct: 'Publish product',
      vatIncluded: 'VAT included',
      description: 'Description',
      upload: 'Upload image',
      addImage: 'Add image',
      productImage: 'Product images',
      noTags: 'No tags available for this product',
    },
    detail: {
      btn: 'Add to list',
      sample: 'Order sample',
      text: 'Shipping costs and VAT not included',
      description: 'Description',
      availability: 'Availability',
      similarProducts: 'Similar products',
      sameBrand: 'Same Brand',
      placeholder: 'Select Size',
      profit: 'Profit',
      cost: 'Cost',
      retail: 'Retail',
      selectAndAdd: 'Select and add to cart',
      warningMessage: "You can't add product, limit of 10 products on cart",
      viewAll: 'View all',
      shipping: 'Shipping in 48-72 hours',
      return: 'Free returns',
      cashbackEarn: 'Hai gia guadagnato',
      sizesTable: 'Sizes table',
      cashback: 'Puoi accumulare ancora [withoutPlan]',
      withoutPlan: 'senza piano social',
      youCanEarn: 'Con questo prodotto puoi accumulare [ofCashback]',
      saveInfo:
        'Risparmio rispetto al prezzo di vendita consigliato dal produttore o distributore',
      ofCashback: 'di cashback',
      limitReached: "You've reached the max cash amount of [maxcashback]",
      maxcashback: 'activate the plan social to earn more cashback',
      discoverPlan: 'discover plan',
      noProducts: 'No sizes found for this product',
      timer1: 'Promo a Tempo North Sails',
      timer2: "L'OFFERTA TERMINERÀ IN:",
      showSizes: 'Show size',
      save: 'Risparmi',
      readMore: 'Leggi di più',
      readLess: 'Leggi meno',
      size: 'Taglia',
      sizeOnLabel: 'Size on label',
      ctaBtn: 'Aggiungi al carrello',
      outOfStock: 'Out of stock',
      discount: 'Extra 10% off',
      cashback50: 'Extra cashback 50%',
      cashback20: 'Extra cashback 20%',
      select: 'Select',
      shareAndEarn: 'Condividi e guadagna',
      copy: "Condividi questo prodotto ai tuoi amici cliccando sull'icona blu ed ottieni Extra Cashback sul tuo Profilo.",
      scopri: 'Scopri di più',
      question: 'Spedizioni',
      answer:
        'Le spese di spedizione sono gratuite per ordini con importo pari o superiore a € 49,90.\n' +
        'Per ordini di importo inferiore le spese di spedizione ammontano a € 6,90.\n' +
        'I prodotti si trovano in diversi magazzini pertanto le consegne potrebbero essere divise in più spedizioni.\n' +
        'Potrai verificare i tracking nella sezione "Ordini" del tuo Profilo.',
      question_1: 'Resi',
      answer_1:
        'Puoi richiedere il reso entro 14 giorni dalla consegna del tuo ordine nella sezione "Ordini" sul tuo Profilo, cliccando su "Richiedi Reso" accanto al riepilogo dell\'ordine.\n' +
        "Il nostro Customer Care ti contatterà indicandoti l'indirizzo a cui dovrai spedire l'articolo reso.",
      question_2: 'Pagamenti',
      answer_2:
        "I metodi di pagamento accettati sono: Paypal, Carta di Credito, Postepay, Contrassegno. Il pagamento alla consegna è disponibile solo per gli utenti registrati: se non l'hai ancora fatto registrati gratuitamente per poterlo selezionare.",
      color: 'COLORE',
      spedizioni: 'Spedizioni in 48-72 ore',
      gratis: 'Gratis a partire da 49.90€',
      freeAlert:
        'Per acquistare questo prodotto, è necessario avere un abbonamento attivo.',
      discoverOurPlans: 'Scopri i nostri piani',
      reso: 'Reso facile',
      reso_p:
        'Se non sei soddisfatto puoi effettuare il reso entro 14 giorni dalla ricezione dell’ordine',
      reso_free: 'Reso gratuito',
      reso_p_free:
        'Se non sei soddisfatto puoi effettuare il reso gratuito entro 20 giorni dalla ricezione dell’ordine',
      pagamenti: 'Pagamenti sicuri',
      pagamenti_p:
        ' Accettiamo carte di credito Visa, Mastercard, PayPal e pagamento alla consegna',
      clients: 'Dicono di noi',
      aiuto: 'Hai bisogno di aiuto?',
      scrivici: 'Scrivici da lunedì a venerdì dalle 9:00 alle 17:30',
      securePayment: 'Secure payment',
      reviews: {
        title_1: 'Anna',
        review_1:
          'Sono davvero soddisfatta\n' +
          'Tempi di spedizione velocissimi e il prodotto era ben raffigurato sul sito! La vestibilità esattamente quella descritta e sono riuscita a scegliere facilmente la taglia corretta senza poi dover effettuare il reso.',
        title_2: 'Jessica',
        review_2:
          'ESPERIENZA POSITIVA\n' +
          'Ho acquistato una borsa Guess tramite Bdroppy e mi sono trovata benissimo! Spedizione veloce, servizio clienti disponibile per le info e prodotto corrispondente al vero. Pagato con un super sconto, per fortuna ho scoperto questo sito.',
        title_3: 'Mauro D.',
        review_3:
          'Per quanto mi riguarda bdroppy è un ottimo sito ho acquistato una giacca husky ad un prezzo veramente vantaggioso la spedizione è stata molto rapida io lo consiglio.',
        title_4: 'Sonia M.',
        review_4:
          'Volevo condividere la mia esperienza con bdroppy, li ho conosciuti tramite instagram e mi sono fidata ho acquistato già 2 volte da loro i prezzi sono davvero scontati di tantissimo anche il 50% in meno.',
        title_5: 'Gennaro',
        review_5:
          'Eccezionale!!! Consiglio BDroppy in quanto mi sono trovato benissimo , è un sito che ho scoperto da poco , ho effettuato il mio primo ordine ed ho ricevuto il tutto in breve tempo e nel massimo della cura ! Sono lieto d esserne cliente e continuerò ad esserlo anche in futuro. Grazie BDroppy',
        title_6: 'Angelo G.',
        review_6:
          'Ottimo sito per acquistare moda griffata on-line! Prezzi super e consegne rapide! Francesca dell’assistenza clienti è stata molto gentile e ha risposto a tutte le mie domande! Se volete risparmiare sui prodotti di qualità bdroppy e’ un sito stra-consigliato!!',
      },
      seo: {
        titleOnlySeason:
          'Selezione [selected season]: prodotti firmati in Dropshipping | BDroppy',
        titleOnlyGender:
          'Selezione [selected gender]: prodotti firmati in Dropshipping | BDroppy',
        titleOnlyBrand: 'Prodotti firmati [H1] in Dropshipping | BDroppy',
        titleSubcategory:
          'Catalogo [H1]: prodotti firmati in Dropshipping | BDroppy',
        titleCategory: '[H1]: i migliori marchi in Dropshipping | BDroppy',
        descriptionOnlySeason:
          "Scopri il catalogo [H1]. Spedizioni rapide e sicure dall'Italia. Prezzi all'ingrosso e Cashback immediato.",
        descriptionOnlyGender:
          "Scopri il catalogo [H1]. Spedizioni rapide e sicure dall'Italia. Prezzi all'ingrosso e Cashback immediato.",
        descriptionOnlyBrand:
          "Scopri il catalogo [H1]. Spedizioni rapide e sicure dall'Italia. Prezzi all'ingrosso e Cashback immediato.",
        descriptionSubcategory:
          "Scopri le offerte del catalogo [H1]. Troverai migliaia di prodotti dei grandi marchi a prezzi all'ingrosso.",
        descriptionCategory:
          "Scopri l'ampia selezione di prodotti in Dropshipping nella sezione [H1]. Prezzi all'ingrosso. Cashback immediato",
        titleDefault:
          'Dropshipping moda firmata a prezzi di ingrosso | BDroppy',
        descriptionDefault:
          "Oltre 120 marchi di moda firmata in pronta consegna, spedizioni rapide e sicure dall'Italia. Capi originali al 100%, a prezzi competitivi. Scopri il catalogo prodotti.",
        descriptionSaving:
          "Acquista in Dropshipping [H1]. Risparmia [x]. Prezzi all'ingrosso. Cashback immediato",
        descriptionNoSaving:
          "Acquista in Dropshipping [H1]. Risparmia con prezzi all'ingrosso. Cashback immediato",
      },
    },
  },
  store: {
    titleBox:
      'Per facilitare la tua esperienza di vendita online con BDroppy abbiamo selezionato queste estensioni per il tuo e-commerce.',
    subTitleBox:
      'Scopri i dettagli e scegli quelle che possono essere più utili per le tue vendite e per la gestione del tuo ecommerce. Il nostro team si occuperà dell’installazione e della configurazione.',
    subTitleBox2:
      'Our team will take care of the installation and configuration.',
    ctaBox: 'Inizia ora!',
    title: 'Service description',
    howToDo: 'How to do',
    addToCart: 'Add to cart',
    viewDetail: 'View detail',
    goToWebsite: 'Go to website',
    wcGoogleAnalytics:
      'Conosci i tuoi clienti e aumenta le vendite con la piattaforma di analisi dati n°1 al mondo.',
    wcFacebook:
      'Sfrutta tutte le potenzialità di Facebook per far crescere la tua attività online.',
    googleAds:
      'Raggiungi milioni di clienti coinvolti su Google con schede di prodotto e annunci sponsorizzati.',
    mailchimp:
      'Trasforma le mail in entrate. Coinvolgi i tuoi utenti con campagne di marketing multicanale.',
    tidio:
      'Coinvolgi i visitatori con una potente piattaforma multifunzione per il servizio clienti.',
    hurryTimer:
      'Crea urgenza e scarsità che guidano i clic dei tuoi clienti e aumentano le vendite.',
    unaTantum: 'Una tantum',
    yearly: 'Yearly',
    monthly: 'Monthly',
    uninstallService:
      'Remember that if you uninstall the plugin on your website you will need to rebuy the service',
    upsell: 'Increase the average value of your e-commerce customers',
    rules:
      'The most popular discount plugin with tons of easy-to-use interface features built to increase sales conversions.',
  },
  services: {
    bsocial: {
      pageTitle: 'BSocial',
      title: "Find out why BDroppy's BSocial is just what you need",
      feature_1: 'It is very easy to use, it just takes one click',
      feature_2:
        'Choose from over 5,000 products and share your favorite one on social media',
      feature_3: 'Start selling to your followers right away',
      feature_4: 'You just need a smartphone',
      cta: 'Start here',
      how_1: '1. Create your own product list',
      how_2: '2. Share one product at a time',
      how_3: '3. Discover the products',
      how_4: '4. Sell ​​immediately',
      how_1_p: 'Choosing from over 5,000 designer fashion items',
      how_2_p: 'With your network of friends, family and followers',
      how_3_p: 'Your community loves most',
      how_4_p: 'With a click!',
    },
    dropshipping: {
      pageTitle: 'Dropshipping',
      title: 'A multi-channel management platform',
      feature_1: 'A catalogue with over 100 top fashion brands',
      feature_2: '100% original branded fashion products',
      feature_3: 'Catalog export in xls, csv, xml, json formats',
      feature_4: 'Fast and reliable shipping from Italy',
      feature_5: 'Multilingual and multicurrency management',
      cta: 'Start here',
      how_1: '1. Create your own product list',
      how_2: '2. Share one product at a time',
      how_3: '3. Discover the products',
      how_4: '4. Sell ​​immediately',
      how_1_p: 'Choosing from over 5,000 designer fashion items',
      how_2_p: 'With your network of friends, family and followers',
      how_3_p: 'Your community loves most',
      how_4_p: 'With a click!',
    },
    turnkey: {
      pageTitle: 'Turnkey',
      title:
        'Would you like a professional turnkey fashion e-commerce and all the BDroppy dropshipping technology?',
      subTitle:
        'We create your online store with a pre-integrated fashion catalog. You’ll have your e-commerce platform ready to start selling right away!',
      feature_1:
        'Customise your site by choosing among 20 languages and 24 currencies!',
      feature_2: 'Domain and hosting included',
      feature_3: 'Mobile friendly Web design',
      feature_4: 'Social oriented',
      feature_5: 'Integrated payment system',
      cta: 'Start here',
      how_1: 'Reach new markets and expand your target;',
      how_2: "Don't be bound by opening hours: your shop will be open 24H / 7",
      how_3: 'Zero inventory costs and risks',
      how_4: 'Take advantage of fast and reliable shipments from Italy',
      how_5: 'Possibility of offering personalized discounts and promotions',
      how: 'Thanks to your own TURNKEY e-commerce you can:',
    },
  },
  pages: {
    dashboard: 'Dashboard',
    productList: 'My import lists',
    createList: 'Create list',
    findProduct: 'Product catalog',
    profile: 'Profile',
    order: 'Order list',
    return: 'Return list',
    newOrder: 'Create new order',
    detail: 'Product detail',
    pricing: 'Pricing',
    home: 'Home',
    admin: 'Admin',
    plansTranslation: 'Plans translations',
    usersManagement: 'Users management',
    returnsManagement: 'Returns management',
    photoDownload: 'Photo download',
    shipping: 'Shipping fees',
    technicalSupport: 'Technical support',
    billsAndCustomers: 'Bills and Customers',
    productTitle: 'Product catalog BDroppy',
    productDescription: 'product bdroppy',
    about: {
      metaTitle: 'About us - Our experience for your business',
      metaDescription:
        'For over 15 years BDroppy has been a leader in the e-commerce sector. Start selling big fashion brands without stock risk',
      title: 'Over 15 years of experience in [titleGradient]',
      titleGradient: 'online fashion',
      titleMobile: 'Over 15 years of experience in online fashion',
      subTitleMobile:
        'Experience, quality, and logistical excellence: this is our trademark.',
      subTitle:
        'BDroppy is an entirely Italian project that was created to make [subTitleBold] We are convinced that high-quality fashion should not be reserved only for an inner circle of people but should be for everyone.',
      subTitleBold:
        '100% original designer fashion garments accessible to the most significant number of people at competitive wholesale prices.',
      ourNumbers: 'Our numbers',
      ourNumbersParagraph:
        'BDroppy is part of BrandsDistribution, a company that has been the benchmark for designer fashion retailers worldwide for over 15 years, providing them with cutting-edge technology at all times. Thanks to this experience, we have partnered with [ourNumbersParagraphBold], allowing us to offer a catalog with the best clothing and accessories selected for you.',
      ourNumbersParagraphBold: 'the best brands and designers in the industry',
      number_1: '+15',
      number_2: '+100',
      number_3: '+450,000',
      number_4: '+60,000',
      numberParagraph_1: 'Years of ecommerce experience',
      numberParagraph_2: 'Top fashion brands',
      numberParagraph_3: 'Registered Users',
      numberParagraph_4: 'Shipments per year',
      fashionEcommerce: 'Not just a [fashionEcommerceGradient]',
      fashionEcommerceGradient: 'fashion e-commerce',
      oneStopShop:
        'BDroppy is the one-stop shop for everyone who loves [oneStopShopBold]. We are happy to offer our customers access to a world of exclusive, high-quality styles at unbeatable prices.',
      oneStopShopBold:
        'high-quality fashion from the most sought-after brands at affordable prices.',
      designer:
        '[designerGradient] on prompt delivery, fast, and safe shipping',
      designerGradient: 'More than 120 designer fashion brands',
      distribution:
        'Our distribution logistics service allows us to guarantee [distributionBold]. We want our customers to feel delighted with the service and quality of our products.',
      distributionBold:
        'reliable shipping times to more than 50 countries around the world',
      quality: 'Quality',
      originalProduct: 'Original products',
      originalProductSubtitle:
        "Only the best clothing and accessories, selected by the industry's top designers and brands",
      value: 'Value',
      wholesalePrices: 'Wholesale prices',
      accessDedicated:
        'Access the dedicated catalog and find competitive wholesale prices on hundreds of products from the best fashion brands',
      speed: 'Speed',
      secureShipping: 'Secure shipping',
      secureShippingSubtitle:
        'Thanks to our distribution logistic service, we guarantee reliable shipping and deliveries in over 50 countries',
      img_1:
        'https://bdroppy.com/wp-content/uploads/2022/12/bdroppy-hero-min.png',
      img_2:
        'https://bdroppy.com/wp-content/uploads/2022/11/exclusive-prices.jpg',
      img_3:
        'https://bdroppy.com/wp-content/uploads/2022/11/fashion-products-1.jpg',
      img_4:
        'https://bdroppy.com/wp-content/uploads/2023/02/fast-shipping-1.jpg',
      img_5: 'https://bdroppy.com/wp-content/uploads/2023/01/e-commerce.png',
    },
    reseller: {
      metaTitle: 'Reseller Area - BDroppy',
      metaDescription:
        'Create your business in fashion with BDroppy. Grow your business online by reselling great fashion brands, with no inventory risk.',
      title: 'Create your own online business with [titleGradient]',
      titleGradient: 'BDroppy',
      subTitle:
        'Do you have an online shop and want to sell our products? Become our business partner and resell thousands of designer fashion products. [subTitleBold]',
      subTitleBold:
        'High profit margins, only original products, no stock risk',
      caption: 'The easiest way to make money selling designer fashion',
      sellOnline: 'Everything you need to sell designer fashion online',
      sellOnlineParagraph:
        'Manage all your dropshipping sales through a single dashboard. Starting selling through BDroppy is as easy as pie! With BDroppy you can upload thousands of designer clothing items, bags, shoes and accessories from the top fashion brands directly to your website or marketplace.',
      titleBox: 'Do you want to sell our brands on a national exclusive basis?',
      titleBox_2: 'Create your business in fashion with BDroppy',
      learnMore:
        'Join our exclusive e-commerce franchising network, bringing authentic Italian shoes and accessories to customers [learnMoreGradient]',
      learnMoreGradient: 'in your own country',
      grow: 'Grow your business online by reselling great fashion brands, with no inventory risk. [sell]',
      sell: 'You sell, we ship to your end customer',
      cta_1: 'Discover our exclusive projects',
      cta_2: 'Find out how it works',
      everythingYouNeed: 'Everything you need to sell designer fashion online',
      manage:
        'Manage all your dropshipping sales through a single dashboard. Starting selling through BDroppy is as easy as pie! With BDroppy you can upload thousands of designer clothing items, bags, shoes and accessories from the top fashion brands directly to your website or marketplace.',
      start: 'Start now',
      tech: 'Technology that simplifies [techGradient]',
      techGradient: 'your business',
      platform:
        'BDroppy is the platform that simplifies the way you do business online and provides you with a catalogue of incredible fashion brands!\n' +
        'Orders automatically synchronized, shipments handled by us at discounted rates; integrations with the main marketplaces and e-commerce platforms; no warehouse risks; professional images for your campaigns…',
      thisIsBdroppy: 'This is BDroppy',
      logistic: '[logisticGradient] excellence',
      logisticGradient: 'Logistic-Distributive',
      logisticParagraph:
        'This is what characterizes our work, carried out with speed, flexibility and passion.\n' +
        'A unique experience that makes us the point of reference for anyone who wants to successfully launch their business in online fashion.',
      sellDesigner: 'Everything you need to sell designer fashion online',
      integrated: 'BDroppy is integrated with',
      findOutMore: 'find out more',
      li_1: 'A catalogue with over 100 top fashion brands',
      li_2: '100% original designer fashion products',
      li_3: 'Fast and reliable shipping from Italy',
      li_4: 'Professional photos for your marketing campaigns',
      li_5: 'A single dashboard for multi-channel management',
      li_6: 'Multilingual and multicurrency management',
      li_7: 'Automatic order and catalog synchronization',
      li_8: 'Catalog export in xls, csv, xml, json formats',
      img_1: 'https://bdroppy.com/wp-content/uploads/2023/01/header-1.png',
      img_2:
        'https://bdroppy.com/wp-content/uploads/2023/01/be-the-only-one.png',
      img_3:
        'https://bdroppy.com/wp-content/uploads/2023/01/dropshipping-1.png',
      img_4:
        'https://bdroppy.com/wp-content/uploads/2023/03/channelBdroppy-3.png',
      img_5:
        'https://bdroppy.com/wp-content/uploads/elementor/thumbs/computer-q1m3g1usayw3m05urlp664476zy6yg1c0wwxh9dkys.png',
      img_6:
        'https://bdroppy.com/wp-content/uploads/2020/07/bdroppy-bg-girl-1.jpg',
      img_7: 'https://bdroppy.com/wp-content/uploads/2023/01/shipping-1.png',
      logo_1:
        'https://bdroppy.com/wp-content/uploads/2021/06/dropshipping-woocommerce.jpg',
      logo_2:
        'https://bdroppy.com/wp-content/uploads/2021/06/dropshipping-prestashop.png',
      logo_3:
        'https://bdroppy.com/wp-content/uploads/2021/06/dropshipping-shpify.jpg',
      logo_4:
        'https://bdroppy.com/wp-content/uploads/2022/07/dropshipping-ekm.png',
      logo_5: 'https://bdroppy.com/wp-content/uploads/2021/11/Squarespace.png',
      logo_6: 'https://bdroppy.com/wp-content/uploads/2022/05/logo-ecwid-1.png',
      logo_7: 'https://bdroppy.com/wp-content/uploads/2022/05/logo-wix.png',
      logo_8:
        'https://bdroppy.com/wp-content/uploads/2022/12/facebook-channel.png',
      logo_9: 'https://bdroppy.com/wp-content/uploads/2022/12/instagram.png',
      logo_10: 'https://bdroppy.com/wp-content/uploads/2022/12/whatsapp.png',
      international: 'Go [internationalGradient] with your sales',
      internationalGradient: 'international',
      internationalParagraph:
        'BDroppy ships to your end customer, in over 50 countries around the world\n' +
        'You sell, we ship!',
      catalog: 'CATALOG IN 20 LANGUAGES AND 24 CURRENCIES',
      countriesList:
        'Dropshipping to the UK, the USA, Canada, France, Germany, Italy, Spain, Austria, Belgium, Denmark, Portugal, United Arab Emirates and many other countries around the world!',
    },
    onlyOne: {
      metaTitle:
        'Upgrade dropshipping service: sell with no competition - BDroppy',
      metaDescription:
        'Create your business in fashion with BDroppy. Grow your business online by reselling great fashion brands, with no inventory risk.',
      title:
        'Discover a unique business opportunity with the [titleBold] program by BDroppy',
      titleBold: 'Be The Only One',
      subTitle:
        'Through the exclusive [titleBold] service, those who already have ' +
        'a well-established e-commerce activity can sell one or more brands of our catalog ' +
        "exclusively in their own country. Be The Only One is an upgrade of BDroppy's " +
        'dropshipping service that helps you eliminate online competition and boost your sales.\n' +
        'Fill in the form, we will consider your application and contact you.',
      fillTheForm: 'Fill the form',
      titleBlock:
        'Eliminate your online competitors and grow your business with a unique program.',
      title_1:
        'You will have the chance to sell one or more brands of our catalog exclusively in your country.',
      title_2: 'You will receive dedicated commercial assistance.',
      title_3:
        'You will have all the BDroppy logistic-distribution system at your disposal.',
      titleBlock_2:
        'Do you have a well established e-commerce business? Here are 3 steps to access the [titleBold] program:',
      li_1: 'Fill in the form with the requested information',
      li_2: 'Tell us if you are interested in one or more brands and categories in our catalog',
      li_3: 'If selected, our team will contact you',
      titleForm: "Let's get to know each other better!",
      email: 'Email address',
      contact: 'Contact name',
      business: 'Describe your online business',
      website:
        'Enter the address of your e-commerce website or the name of your store on Amazon and/or eBay',
      brand:
        'Which brand(s) in our catalog are you interested in having the exclusivity for?',
      country: 'Which country would you like the exclusivity for?',
      mobile: 'Mobile phone number:',
      privacy: 'Information privacy:',
      term: 'I grant my consent to the use of my personal data for marketing purposes',
      submit: 'Submit',
      formSubmitted: 'Submitted successfully',
      thankYou: 'Thank you!',
      img_1:
        'https://bdroppy.com/wp-content/uploads/2021/09/bdroppy_header-brandsdistribution.jpg',
      img_2: 'https://bdroppy.com/wp-content/uploads/2021/09/onyone-icon.png',
      img_3:
        'https://bdroppy.com/wp-content/uploads/2021/09/assistance-icon.png',
      img_4:
        'https://bdroppy.com/wp-content/uploads/2021/06/ourServices-icon-2.png',
      img_5: 'https://bdroppy.com/wp-content/uploads/2023/01/e-commerce.png',
      img_6:
        'https://bdroppy.com/wp-content/uploads/elementor/thumbs/channelBdroppy-3-q39gjuvhvw1rs0dukrqixo83kuiem3zygc4xwlynsy.png',
    },
    influencer: {
      metaTitle: 'BDroppy influencer program',
      metaDescription: '',
      title: 'BDroppy Influencer Program',
      subTitle: 'Ciao, siamo felici di fare la tua conoscenza.',
      description:
        'On [descriptionBold] you find thousands of designer products from the trendiest brands at wholesale prices..',
      descriptionBold: 'BDroppy',
      video: 'https://www.youtube.com/embed/WmBAj7nkg4Y',
      description_2:
        'Share them with your community on Instagram, Facebook , Tiktok or Telegram and [descriptionBold_2] on purchases generated by your followers for the next 12 months.',
      descriptionBold_2: 'earn 10% NOW',
      descriptionInfluencer:
        'Come fare?\n' +
        'Ti basta seguire questi quattro, semplicissimi, passaggi:',
      description_li_1: '1 - Compila i dati nel form qui sotto',
      description_li_2:
        "2 - Ricevi subito via mail il codice di affiliazione UNIVOCO, generato per te e l'accesso al tuo pannello di controllo",
      description_li_3:
        '3 - Condividi BDroppy o i prodotti che preferisci con il tuo codice di affiliazione sulla tua community e inizia a guadagnare subito',
      description_li_4:
        '4 - Raggiungi 100€ di credito e richiedi l’accredito del bonifico  ',
      cosaAspetti: 'Cosa aspetti ?\n' + 'ISCRIVITI SUBITO!',
      cta: 'Compila il form e conosciamoci',
      titleForm: "Let's get to know each other better!",
      email: 'Email address',
      contact: 'Contact name',
      business: 'Describe your online business',
      website:
        'Enter the address of your e-commerce website or the name of your store on Amazon and/or eBay',
      brand:
        'Which brand(s) in our catalog are you interested in having the exclusivity for?',
      country: 'Which country would you like the exclusivity for?',
      mobile: 'Mobile phone number:',
      privacy: 'Information privacy:',
      term: 'I grant my consent to the use of my personal data for marketing purposes',
      submit: 'Submit',
      formSubmitted: 'Submitted successfully',
      thankYou: 'Thank you!',
      img_1: 'https://www.mediabd.it/assets/public/2023-2/07/closeup.jpg',
    },
    cashback: {
      metaTitle: 'Shop on BDroppy and get 10% cashback',
      metaDescription:
        'With one link, you earn, and with one click, you save. With BDroppy it has never been easier!',
      title: '[shop] and [save]',
      shop: 'Shop',
      save: 'save',
      subTitle:
        'Receive an instant 10% cashback on the value of each of your purchases.',
      title_2: '[share] and [earn]',
      share: 'share',
      earn: 'earn',
      subTitle_2: 'Share our products with a friend, 10% for you for 12 months',
      img_1: 'https://bdroppy.com/wp-content/uploads/2023/03/6228458-2.png',
      titleCashback: 'What is BDroppy [cashbackGradient]',
      cashbackGradient: 'Cashback',
      cashbackSubtitle:
        'Cashback is 10% of your spending, credited back to you as a shopping voucher for your future purchases on BDroppy\n' +
        '\n' +
        'For example, if you spend €100 we will immediately refund €10 in your BDroppy balance to spend on future purchases!',
      whyChooseSubtitle:
        'Only we give you cashback on your purchases and those of your friends.\n' +
        'You will receive a 10% credit with no waiting time.',
      whyChooseTitleGradient: 'choose us',
      whyChooseTitle: 'Why [whyChooseTitleGradient]',
      receive: 'Receive [receiveBlue] on all products',
      receiveBlue: '10% cashback',
      receive_1: 'Receive 10% on [receiveBlue_1] for 12 MONTHS!',
      receiveBlue_1: "your friends' purchases",
      receive_2: '[receiveBlue_2] cashback, with no waiting time',
      receiveBlue_2: 'IMMEDIATE',
      receive_3: 'Claim a credit or use it for [receiveBlue_3]',
      receiveBlue_3: 'new purchases',
      img_2:
        'https://bdroppy.com/wp-content/uploads/2023/03/laughing-women-using-smartphone-together-2.jpg',
      img_3:
        'https://bdroppy.com/wp-content/uploads/2023/03/Isolated_right_hand_with_smartphone.png',
      title_3: 'Sharing with your friends [title_Gradient]',
      title_Gradient: 'is easy',
      subtitle_3:
        'Choose one product you like or select more than one to create a wishlist and share them directly from your cell phone to your friends and you will receive from BDroppy an extra 10% cashback from their purchases.\n' +
        'The more you share, the more cashback you accumulate for 12 months!',
      cta: 'Access the catalog and share!',
      cta_2: 'Get started now',
      withOneClick: 'With one link [youEarn], and with one click [youSave]',
      youEarn: 'youEarn',
      youSave: 'you save',
      easier: 'With BDroppy, it’s never been easier!',
      registerOnBdroppy: 'Register on BDroppy',
      free: 'Free plan',
      social: 'Social plan',
      li_1: 'Create your Showcase of UP TO 100 PRODUCTS!',
      li_2: 'Cashback of 10% on your purchases',
      li_3: 'Cashback of 10% on purchases of people you invite',
      li_4: 'UNLIMITED Cashback',
      li_5: 'Bank transfer request',
    },
    integrations: {
      metaTitle: 'Integrations BDroppy',
      metaDescription: 'Integrations BDroppy',
      title: 'Dropshipping BDroppy: [titleBold]',
      titleBold: 'available integrations and apps',
      subTitle:
        'The BDroppy dropshipping service allows you to connect our catalog of designer fashion products to your online store or to the best marketplaces, without any stock risk and without having to deal with shipments.\n' +
        '\n' +
        'Sell the best fashion products with no minimum order quantity.\n' +
        'Start your dropshipping business: choose your channel now!',
      integrations: 'integrations',
      woocommerce: 'Woocommerce Dropshipping',
      wooSubtitle:
        'Selling in dropshipping with Woocommerce is a pretty simple procedure. Once you have created your e-commerce, you should select the dropshipping service provider and look for a plugin to include and synchronize its products. Thanks to BDroppy, you can have your site configured with our fashion catalog integrated. Through the plugin, all data (products, prices and orders) will be automatically synchronized.',
      shopify: 'Shopify Dropshipping',
      shopSubtitle:
        'Shopify is definitely one of the most used online sales platforms: creating a store with Shopify is very simple and this means that it is used a lot all over the world. Would you like to sell the best fashion products on your Shopify store without big investments?Use our app to sell fashion on Shopify in dropshipping, in just a few steps, and our catalog will be uploaded to your online store',
      prestashop: 'Prestashop Dropshipping',
      preSubtitle:
        'Prestashop is a free e-commerce platform for online sales that helps small and large businesses create online stores in a simple way and without sales commissions. If you want a multi-language and multi-currency shop with a large integrated fashion catalog choose your dropshipping plan with BDroppy now: we will take care of shipments worldwide and you will manage your sales from a simple dashboard!',
      squarespace: 'Squarespace Dropshipping',
      squaSubtitle:
        'Squarespace is a paid site builder. By subscribing you gain access to a wide range of tools that you can use to design your site, without the need for coding skills or Web development. Do you want to connect BDroppy to your Squarespace store and sell designer products in dropshipping? No problem, the integration is now available!',
      ecwid: 'Ecwid Dropshipping',
      ecwSubtitle:
        'Dropshipping with Ecwid is easy! Ecwid is a platform that allows you to create your e-commerce with your products in as many marketplaces as possible and allows you to create your online showcase and incorporate it to other platforms. Combine Ecwid with the BDroppy catalog, and start selling designer fashion without worrying about shipping and without having to anticipate the purchase of the goods! Connect your Ecwid shop with the BDroppy catalog.',
      wix: 'Wix Dropshipping',
      wixSubtitle:
        'If you have created your ecommerce site with WIX, you can easily integrate it with the BDroppy catalog. Thanks to our plugin, you can enrich your shop with thousands of designer fashion products, and the orders and available products will be automatically synchronized. You won’t have any stock risks and we’ll take care of the shipments. Manage your catalog from the dashboard and start selling the most requested products right away!',
      ekm: '\n' + 'EKM dropshipping',
      ekmSubtitle:
        'Discover how easy it is to sell online thanks to EKM! EKM is a site builder that allows you to design your site and customize it according to your needs.\n' +
        '\n' +
        'If you want to connect BDroppy to your EKM store to sell in dropshipping without worrying about the warehouse or shipping, no problem: the integration is now available!',
      title_2: 'What are you waiting for?',
      subTitle_2:
        'You can integrate the BDroppy catalog of great fashion brands with one or more sales channels choosing from the main marketplaces, your existing e-commerce, or if you want, we can create for you a turnkey website with our catalog already included!',
      img_1:
        'https://bdroppy.com/wp-content/uploads/2021/11/dropshipping-integrazione-woocommerce-c.jpg',
      img_2:
        'https://bdroppy.com/wp-content/uploads/2021/11/dropshipping-integrazione-shopify-c.jpg',
      img_3:
        'https://bdroppy.com/wp-content/uploads/2021/11/dropshipping-integrazione-prestashop-c.jpg',
      img_4:
        'https://bdroppy.com/wp-content/uploads/2021/11/dropshipping-integrazione-squarespace-c.jpg',
      img_5:
        'https://bdroppy.com/wp-content/uploads/2022/05/dropshipping-integrazione-ecwid-c-1.jpg',
      img_6:
        'https://bdroppy.com/wp-content/uploads/2022/05/dropshipping-integrazione-wix-c.jpg',
      img_7:
        'https://bdroppy.com/wp-content/uploads/2022/07/dropshipping-integrazione-ekm-c.jpg',
    },
    dropshipping: {
      metaTitle: 'dropshipping',
      metaDescription: 'dropshipping',
      title:
        'Do you want to grow your online business without risking large initial investments and [titleBold]',
      titleBold: 'without having to take care of shipments?',
      title_2: 'ALL THIS IS POSSIBLE THANKS TO [bdroppy]',
      subTitle:
        'Our dropshipping service allows you to connect our catalogue to your online store without\n' +
        'having to purchase products in advance or have to take care of shipments.',
      cta_1: 'Start now',
      cta_2: 'Find out more',
      bdroppy: 'BDroppy',
      multiChannel: 'A multi-channel management platform',
      integratedWith: 'BDroppy is integrated with',
      img: 'https://bdroppy.com/wp-content/uploads/2020/11/Dropshipping.png',
      img_1:
        'https://bdroppy.com/wp-content/uploads/elementor/thumbs/channelBdroppy-3-q39gjuvjpo7ki4m0p10lb4qmk35jowurdsry39w21s.png',
      howItWorks_1:
        'You receive the payment of a order on your store. The order is sent to us automatically.\n' +
        "You don't need to do anything",
      howItWorks_2: 'You will then carry out to us the payment of the order',
      howItWorks_3:
        'Within 24h from the payment, we will ship the goods directly to your end customer, with neutral packages and no reference to our company',
      howItWorks_4:
        'You will be able to access at any time, both to check the status of the order and follow its progress, and to check the shipment thanks to the tracking number',
    },
  },
  sidebar: {
    home: 'Home',
    elettronica: "Elettronica",
    yourOrders: 'Your orders',
    hello: 'hello,',
    appStore: 'Apps',
    productCatalog: 'Shop by category',
    allCategory: 'All catalog',
    moda: 'Moda',
    sexyShop: 'Sexy Shop',
    giftBoxes: 'Gift boxes',
    casa: 'Home',
    resellerArea: 'Area business',
    createList: 'Create your first list',
    resources: 'Resources',
    myList: 'Import lists',
    salesChannel: 'Sales channel',
    myStore: 'Store',
    orders: 'Orders',
    orderList: 'Order list',
    return: 'Return list',
    photo: 'Photo download',
    faq: 'Faq and tutorials',
    technical: 'Technical support',
    pricing: 'Pricing',
    affiliation: 'Affiliation',
    promo: 'Promo',
    admin: 'Admin',
    plansTranslations: 'Plans features',
    labelTranslations: 'Translations',
    usersManagement: 'Users management',
    returnsManagement: 'Returns management',
    invoicesManagement: 'Invoices management',
    upgrade: 'Upgrade plan',
    startBusiness: 'Start your business',
    shipping: 'Shipping fees',
    billsAndCustomers: 'Bills and Customers',
    createNewList: 'Create new list',
    privacy: 'Privacy Policy',
    blog: 'Blog',
    terms: 'Terms and conditions',
    collapse: 'Collapse',
    management: 'Management',
    services: 'Services',
    turnkey: 'Turnkey Webstore',
    dropshipping: 'Dropshipping',
    bsocial: 'BSocial',
    title: "It's time to start!",
    subTitle: 'Grow your online business',
    titleUpgrade: 'Upgrade plan!',
    subTitleUpgrade: 'Grow your online business',
    modal: {
      title: 'Upgrade plan',
      subTitle1List:
        'You already have one list, you can create just one list with your role. If you want to create another list upgrade your plan',
      subTitle3Lists:
        'If you need another list or need a turnkey website contact us we will be happy to help you.',
      upgrade: 'Upgrade plan',
      bookCall: 'Book a call',
      title3Lists: 'Need more lists?',
    },
    newList: 'New list',
    aidifyText: 'Incrementa le tue vendite con Aidify',
    aidifyCta: 'Provalo gratis',
  },
  auth: {
    forget: 'Forgot password?',
    sendLink: 'Send link',
    createPassword: 'Create password',
    createPasswordText: 'Insert your new password',
    back: 'Back',
    forgetSubtitle:
      'Insert you email address and insert your new password. You will receive a confermation email.',
    erroEmail: 'You must insert a valid email',
    welcome: 'Welcome to BDroppy!',
    fewQuestion:
      'Just a few questions to offer you the best solution to grow your online business together',
    emailSendTitle: 'Email sent',
    emailSendSubtitle:
      'You will receive an email for the confirmation of new password',
    passwordCreatedText: 'Password created, now you can login',
    goToLogin: 'Go to login',
    passwordCreatedTitle: 'Password created',
    registered: 'Not yet registered?',
    signup: 'Sign up to BDroppy',
    keep: 'Keep me signed',
    getstarted: 'Get started',
    subtitle:
      'Register for free to see the products in the catalog and discover all the features of BDroppy!',
    already: 'Already registered?',
    register: 'Register',
    continueRegister: 'Continue registration',
    loginto: 'Login to BDroppy',
    forgot: 'Forgot password?',
    login: 'Log in',
    create: 'Create your account ',
    mobile: 'Insert your mobile number',
    name: 'Name',
    email: 'Email',
    password: 'Password',
    privacy:
      'I accept [privacy1] and [privacy2] and I consent to receive updates and communications from BDroppy',
    privacy1: 'terms of use',
    privacy2: 'privacy policy',
    optional: 'Optional',
    howDidYouDiscoverBDroppy: {
      title: 'How did you discover BDroppy?',
      option1: 'Through advertising on Facebook / Instagram',
      option2: 'Through Google or other search engines',
      option3: 'On YouTube',
      option4: 'By word of mouth',
      option5: 'Through the Brandsdistribution website',
      option6: 'Other',
    },
    sidebar: {
      title:
        'Thousands of designer fashion products, a unique dashboard for your dropshipping business',
      list1: 'Dropshipping service',
      list2: 'Over 100 fashion brands in the catalogue',
      list3: 'Integrations with Amazon and eBay',
      list4: 'Plugins for Prestashop, Woocommerce and Shopify',
      list5: 'Turnkey e-commerce website solution',
      list6:
        'Soluzione sito e-commerce chiavi in mano + dropshipping integrato',
      list7:
        'BSocial: vendi sui tuoi social network preferiti, senza e-commerce',
    },
    selectCountry: 'Select your country',
    alreadySell: {
      title: 'Do you already sell online?',
      option1: 'Yes',
      option2: 'No',
      website: 'Website',
      description: 'Activity description',
    },
    revenue: {
      title: 'Qual è il tuo fatturato medio annuale',
      option1: 'Più di 100.000€',
      assistance:
        'Ti piacerebbe essere seguito da una consulente commerciale dedicata?',
    },
    selectPrefix: 'Select prefix',
    phoneNumber: 'Phone number',
    alreadyInUse: 'Email already in use',
    invalidEmail: 'Email Address is not valid.',
    insertCountry: 'To complete the registration please enter your country',
    completeSocialRegistration: 'Complete registration',
    googleLogin: 'Login with Google',
    facebookLogin: 'Login with Facebook',
    googleSignup: 'Sign up with Google',
    facebookSignup: 'Sign up with Facebook',
    enableCookies:
      'To sign in with google go to cookie settings and enable third party cookies',
    genericGoogleError: 'Logging in with google is not possible right now',
    wrongCredentials: 'Username or password is incorrect.',
    noEmailFromSocial:
      'Registration could not be completed. Please enter an email address on your Facebook account and try signing in again',
    roleExpired: 'Could not log in, please contact customer service',
    forceToResetPassword: 'Please reset password',
  },
  admin: {
    title: 'admin',
    plans: 'plans',
  },
  photoDownload: {
    select: 'Select a brand',
  },
  shippingFees: {
    title: 'Shipping fees for dropshipping orders',
    subTitle:
      'We ship to customers throughout Europe, USA and many other countries. Find out more on the shipping costs divided by geographical areas.',
    europe: 'Europe',
    title_2:
      "We'd like to inform our customers that deliveries by [span] be guaranteed for orders that are confirmed",
    span: 'Christmas will ONLY',
    subtitle_2:
      'Italia per ordini confermati entro il 18/12 con servizi express',
    subtitle_3:
      'Europa, Uk, Usa per ordini confermati entro il 16/12 con servizio express',
    exEurope: 'Extra Europe',
    euPost: 'POST - Delivery in 4-8 working days',
    ItalyPost: 'Italy',
    euPostCol1: 'Europe*',
    cyprus: 'Cyprus',
    malta: 'Malta',
    cyprusPost: 'Delivery in 6-8 working days (BRT)',
    euPostCol2: 'Germany, Spain',
    euPostCol3: 'Austria, Belgium, France, Netherlands',
    euPostCol4:
      'Croatia, Estonia, Lithuania, Poland, Czech Republic, Slovenia, Hungary',
    euPostCol5: 'Denmark, Latvia, Finland, Romania, Slovakia, Sweden',
    euPostCol6: 'Luxembourg, Portugal',
    euPostCol7: 'Bulgaria, Greece',
    euPostCol8: 'Malta',
    euStandard: 'STANDARD - Delivery in 3-5 working days',
    euStandardCol1: 'Austria, France, Germany',
    euStandardCol2: 'Belgio, Spain, Luxembourg, Netherlands',
    euStandardCol3: 'Croatia, Slovenia',
    euStandardCol4:
      'Bulgaria, Denmark, Estonia, Finland, Ireland, Lithuania, Latvia, Poland, Portugal, Czech Republic, Romania, Slovakia, Sweden, Hungary',
    euStandardCol5: 'Greece',
    euStandardCol6: 'Switzerland',
    euStandardCol7: 'Norway',
    euExpress: 'EXPRESS - Delivery in 2-3 working days',
    euExpressCol1: 'Italy',
    euExpressCol2:
      'Austria, Belgium, France, Germany, Netherlands, Principality of Monaco',
    euExpressCol3:
      'Denmark, Finland, Ireland, Portugal, United Kingdom (Northern Ireland only), Sweden',
    euExpressCol4:
      'Bulgaria, Cyprus, Lithuania, Latvia, Malta, Poland, Romania, Hungary, Estonia, Slovakia,  Spain, Czech Republic, Greece, Luxembourg',
    exEuStandard: 'STANDARD - Delivery in 5-10 working days',
    exEuStandardT1Col1: 'United Kingdom',
    exEuStandardT2Col1: 'Canada',
    exEuStandardT3Col1: 'USA',
    exEuExpress: 'EXPRESS - Delivery in 2-5 working days',
    unitedKingdom: "United Kingdom",
    unitedKingdomPost: "POST - Delivery in 2-5 working days",
    italy: 'Italy',
    italyPost: 'POST - Delivery in 3-4 working days',
    exEuExpressT1Col1: 'Cina,Hong Kong, Indonesia, Giappone, Malaysia',
    exEuExpressT1Col2:
      'Nuova Zelanda',
    exEuExpressT1Col3: 'Singapore, Thailandia',
    exEuExpressT1Col4: 'Taiwan',
    exEuExpressT1Col5: 'Stati Uniti d\'America',
    exEuExpressT2Col1: 'United Arab Emirates',
    exEuExpressT3Col1: 'Australia',
    exEuExpressT4Col1: 'Canada',
    exEuExpressT5Col1: 'Saudi Arabia',
    country: 'Country',
    weightRange: 'Weight range',
    price: 'Price',
    important: 'Important',
    importantText:
      'Shipping costs are to be considered VAT excluded and are to be paid by the buyer. For direct shipments to USA, if the order value is below 800 USD custom duties are not applied. For shipments to extra EU countries, the customs duties and fees may be applied depending on the regulations of the country of destination of the goods. Please contact your local customs office for more information.',
    importantNB:
      '*Italy, Germany, Spain (Canary Island excluded), Austria, Belgium, Bulgaria, Croatia, Estonia, Finland, France, Luxembourg, Netherlands, Czech Republic, Hungary, Slovenia, Slovakia, Ireland, Latvia, Lithuania, Poland, Romania, Denmark, Portugal, Sweden, Greece, Malta',
  },
  technicalSupport: {
    title: 'Technical support',
    subTitle1:
      'Do you need a specialist at your disposal? Choose TECHNICAL SUPPORT for a customized intervention.',
    subTitle2:
      'With our TECHNICAL SUPPORT we offer you a wide range of customized professional services designed to save you time and help you sell faster.',
    step1Title: 'What it includes',
    step1List1: 'Plugin installation',
    step1List2: 'Verification of the correct import of products',
    step1List3: 'Transmission of the first test order',
    step1List4:
      'Dedicated monitoring during the 48h following the installation',
    addToCart: 'ADD TO CART',
    goldSupport: 'GOLD SUPPORT',
    step2Thank:
      'Thank you, we received your payment. In order to take in charge your request, it’s mandatory to fill up this form:',
    website: 'Website',
    URLLoginAdmin: 'URL Login Admin',
    username: 'Username',
    password: 'Password',
    FTPAddress: 'Address',
    FTPPorta: 'Port',
    FTPProtocol: 'Protocol',
    FTPUsername: 'Username',
    FTPPassword: 'Password',
    FTPNote: 'Notes',
    continue: 'CONTINUE',
    FTPFormTitle: 'FTP ACCESS TO WEBSHOP SERVER',
    thankYouTitle: 'Thank you!',
    thankYouSubtitle:
      'We have received your request. Our IT department will contact you as soon as possible',
  },
  extraField: {
    messageHome:
      "Great news coming soon: don't miss all our communications in real time, [cta]",
    hrefHome: '/pricing',
    ctaHome: 'follow us on Instagram!',
    message:
      'Sell designer fashion in dropshipping. Ship all over Europe for only 6.90 € - [cta]',
    cta: 'DISCOVER OUR SHIPPING FEES',
    href: '/shipping-fees',
    blog: {
      img: 'https://bdroppy.com/wp-content/uploads/2022/02/dropship-bags-pierre-cardin-superdeal-blog.jpg',
      imgAlt: 'New arrivals',
      href: 'https://bdroppy.com/2022/02/09/dropship-discounted-handbags-pierre-cardin/',
    },
    shipping:
      'SPESE DI SPEDIZIONI GRATUITE PER ORDINI PARI O SUPERIORI A 100€ IN TUTTA EUROPA [icon_1]',
    shipping_2: 'E  200$ in USA  [icon_2]',
    icon_1: 'emojione:flag-for-european-union',
    icon_2: 'emojione:flag-for-united-states',
    icon_3: 'emojione:flag-for-united-kingdom',
    and: 'and [icon_3]',
  },
  shop: {
    availabilityError: 'Not enough availability for product',
    selectSize: 'Select size',
    selectColor: 'Select color',
    sizesGuide: 'Sizes guide',
    availability: 'Availability',
    description: 'description',
    yourAddress: 'Your address',
    goToCart: 'Go back to cart',
    name: 'Name',
    email: 'Email',
    streetName: 'Street name',
    zip: 'Zip',
    city: 'City',
    province: 'Province',
    country: 'Country',
    prefix: 'Prefix',
    phoneNumber: 'Phone number',
    saveAddress: 'Save address',
    yourCart: 'Your cart',
    size: 'Size',
    quantity: 'Quantity',
    totalProduct: 'Total product',
    buyItFor: 'Buy it for',
    checkout: 'Checkout',
    shipping: 'Shipping',
    terms: "I've read and accept [privacy1] and [privacy2]",
    privacy: "I've read and accept [privacy1] and [privacy2]",
    privacy1: 'terms of use',
    privacy2: 'privacy policy',
    privacy1Link: 'https://bdroppy.com/terms-and-conditions/',
    privacy2Link: 'https://bdroppy.com/privacy-policy/',
    share: 'Share',
    paymentInfo: 'Payment info',
    paypalInfo:
      'You will be redirected to PayPal payment form in order to finish payment process',
    paymentComplete: 'Thank you for your purchase!',
    insertShippingAddress: 'Insert shipping address',
    noShipping: 'Payment disabled because shipping is not available to ',
    availability0: 'Product out of stock',
    total: 'Total',
    needToBeCalcuated: 'Will be calculated after country selection',
    vatUpdated: 'Vat has been uptaded',
    cashback: 'Cashback',
    orderRecap: 'Order recap',
    myCollections: 'My collection',
    viewDetail: 'View detail',
    back: 'View collection',
    textCashback: 'Your cashback will be charged on your bdroppy account',
    continueShopping: 'Continue shopping',
    orderRecapBelow: 'Here below you can find your order recap',
    orderConfirmed:
      'You will soon receive an email with order confirmation and your invoice',
    orderCompleted: 'Order completed',
    orderTotal: 'Order total',
    selectQuantity: 'Select quantity',
    insertAddress: 'Insert address',
    cost: 'Cost',
    vat: 'VAT',
    noAddress: 'Fill in the address to get the total',
    continuePayment: 'Continue payment',
    addTocart: 'Add to cart',
    productAddedStore: 'Product added to store',
    productRemovedStore: 'Product removed from store',
    productMaxLimit: 'Limit of products reached',
    errorRemoveProduct: 'Error in removing the product from your wishlist',
    shareStore: 'Look at my store!',
    billingAddress: 'Indirizzo di fatturazione',
    selectSameAddress:
      "scegli se usare lo stesso indirizzo o inserirne uno nuovo al momento dell'inserimento dati carta",
    cardPayment: 'Per pagamenti con carta di credito o debito',
    sameAddress: ' Indirizzo fatturazione uguale a spedizione',
    newAddress: 'Utilizza nuovo indirizzo',
    preHeaderText: 'Discover all products on BDroppy',
    headerText: 'Take a look at my selection',
    footerText: 'View all product catalog on BDroppy',
    footerPreText: '',
    cta: 'Go to Bdroppy',
    securePayment: 'Secure payment',
    shippingInfo: 'Fast shipping from Italy',
    sameBrand: 'Same brand',
    sameBrandSub: 'Same brand text',
    similarProducts: 'Similar products',
    similarProductsSub: 'Similar products text',
    title_1: 'prodotti originali',
    title_2: "prezzi all'ingrosso",
    title_3: "Spedizioni dall'Italia",
    cashbackInfo:
      "Riceverai il cashback subito. Procedi con l'acquisto del prodotto, il cashback verrà accreditato al tuo account BDroppy.",
    account: 'Hai gia un account? [login]',
    login: 'Accedi',
    shareProduct: 'Condividi il prodotto',
    extraCash: 'Non sei interessato all’extra cashback?',
  },
  landing: {
    img1: 'https://bdroppy.com/wp-content/uploads/2022/05/01-gucci_EN.jpg',
    img2: 'https://bdroppy.com/wp-content/uploads/2022/05/02-karl-lagerfeld_EN.jpg',
    img3: 'https://bdroppy.com/wp-content/uploads/2022/05/03-tommy-hilfiger_EN.jpg',
    img4: 'https://bdroppy.com/wp-content/uploads/2022/05/04-guess_EN.jpg',
    img5: 'https://bdroppy.com/wp-content/uploads/2022/05/05-love-moschino_EN.jpg',
    img6: 'https://bdroppy.com/wp-content/uploads/2022/05/06-napapijri_EN.jpg',
    img7: 'https://bdroppy.com/wp-content/uploads/2022/05/07-calvin-klein_EN.jpg',
    img8: 'https://bdroppy.com/wp-content/uploads/2022/05/08-diesel_EN.jpg',
    step1: 'Scegli il prodotto',
    step2: 'Condividilo con i tuoi amici',
    step3: 'Fai la tua vendita',
    step4: 'Noi spediamo',
    step5: 'Incassa il denaro',
    discoverProducts: 'SCOPRI TUTTI I PRODOTTI',
    createAccount: 'CREA IL TUO ACCOUNT GRATUITO',
    footerTitle: 'Fai decollare le tue vendite con BDroppy!',
    footerSubTitle:
      'Oltre 120 marchi di moda firmata in pronta consegna, spedizioni rapide e sicure.',
    startNow: 'INIZIA ORA',
    findOutMore: 'SCOPRI DI PIÙ',
    turnkey: 'Vuoi una soluzione professionale chiavi in mano?',
    turnkeySubTitle:
      'Il nostro team creerà per te un sito e-commerce pronto all’uso, personalizzato e integrato con il servizio dropshipping di BDroppy.',
    preventivo: 'RICHIEDI UN PREVENTIVO',
    brandTitle:
      'E ci occupiamo anche delle spedizioni: tu vendi, noi spediamo!',
    brandSubTitle:
      'I tuoi amici, follower o clienti potranno acquistare in pochissimi click e riceveranno direttamente il prodotto in pochi giorni, grazie alle spedizioni rapide e sicure di BDroppy.',
    muchMore: 'E molti altri...',
    question: 'Il modo più facile per un guadagno extra?',
    answer: 'Vendi moda firmata con ',
    bdroppy: 'BDroppy',
    productTitle:
      'BDroppy è l’unica piattaforma che ti consente di vendere moda firmata online,',
    productTitle2: 'senza neanche bisogno di un e-commerce!',
    productSubTitle: 'Ecco alcuni dei marchi che potrai vendere subito',
    haveAChannel: 'Hai già un canale di vendita?',
    saleChannel: 'Fai crescere il tuo business online con il',
    droppshippingService: 'servizio dropshipping di BDroppy.',
    brand: 'Ecco alcuni dei marchi che potrai vendere in dropshipping:',
    earn: 'Guadagna.',
    sell: 'Vendi.',
    share: 'Condividi.',
    isFree: 'Inizia subito è gratis',
    getstarted: 'Get started',
    welcome: 'Welcome',
    shareTitle: 'Guadagna su ogni singola vendita, nessuna commissione extra.',
    shareSubTitle:
      'Con il piano BSocial potrai vendere sui tuoi social network preferiti i prodotti che vuoi condividere, in modo facile e veloce. Ti basta uno smartphone!',
    b2c: {
      imgHeader:
        'https://bdroppy.com/wp-content/uploads/2023/03/header-B2C.png',
      title_1: 'Amante della moda e del risparmio?',
      title_2:
        "Su BDroppy trovi migliaia di prodotti di moda firmata con sconti fino all'80% e non solo.",
      subtitle: '[highlight] IMMEDIATO, su ogni tuo acquisto!',
      highlight: 'Ottieni il 10% di cashback',
      footerTitle: 'Scelto da oltre [footerSpan] in tutto il mondo',
      footerSpan: '450.000 appassionati di moda',
      discoverProducts: 'Scopri tutti i prodotti',
      category_title: 'Perché Scegliere BDroppy?',
      category_p:
        'Solo su BDroppy puoi ricevere il 10% di CASHBACK su tutti i tuoi acquisti e quelli dei tuoi amici.',
      category_p_2: 'Acquista la moda a prezzi scontati e ricevilo SUBITO!',
      icon_title_1: '+120',
      icon_label_1: 'marchi originali',
      icon_title_2: '+15',
      icon_label_2: 'anni di esperienza',
      icon_title_3: '+60.000',
      icon_label_3: "spedizioni all'anno",
      createAccount: 'Crea il tuo account gratuito',
      brands_title:
        'Potrai scegliere tra migliaia di prodotti e [gradientText] e [gradientText2]',
      gradientText: 'oltre 120 marchi',
      gradientText2: 'moda firmata',
      CTAhome: 'Iscriviti subito',
    },
    b2b: {
      title_1:
        'il modo più facile per guadagnare grazie alla vendita di moda firmata. Vendi e guadagna [title_2] su ogni singola vendita',
      title_2: 'fino al 30%',
      subtitle: 'Crea il tuo [highlight] online con BDroppy!',
      highlight: 'business',
      footerTitle: 'Scelto da oltre [footerSpan] in tutto il mondo',
      footerSpan: '450.000 appassionati di moda',
      discoverProducts: 'Scopri tutti i prodotti',
      category_title: "Cos'è BDroppy?",
      category_p:
        "Bdroppy è la prima piattaforma di social-ecommerce di moda firmata, dove puoi trovare i tuoi marchi preferiti con sconti fino all'80% su abbigliamento, calzature, borse e accessori",
      icon_label_1: 'Alti margini di guadagni',
      icon_label_2: '+120 marchi di moda',
      icon_label_3: 'Spedizioni rapide e sicure',
      createAccount: 'Crea il tuo account gratuito',
      brands_title:
        'Potrai scegliere tra migliaia di prodotti e [gradientText] e [gradientText2]',
      gradientText: 'oltre 120 marchi',
      gradientText2: 'moda firmata',
      CTAhome: 'Iscriviti subito',
      video: 'https://youtu.be/Qu4h-zCU5ss?si=WVCI41U-DcPCr1aD',
      products:
        'Migliaia di prodotti di moda, infinite possibilità di business',
      shareAndEarn: 'Condividi. Vendi. Guadagna',
      li_1: 'Un catalogo con oltre 100 marchi di moda firmata',
      li_2: 'Prodotti firmati 100% originali',
      li_3: 'Spedizioni rapide e affidabili in tutto il mondo',
      li_4: 'Nessuna commissione sul venduto',
      li_5: 'Suggerimenti e consigli di vendita settimanali',
      li_6: 'Foto in alta definizione e materiale pubblicitario gratuito',
      li_register: 'Registrati subito',
      haveAChannel:
        'Con Bdroppy vendi direttamente su Amazon, Ebay, WooCommerce, Prestashop, Shopify, Squarespace e condividi sui tuoi canali social preferiti.',
      saleChannel:
        'Con Bdroppy vendi direttamente su Amazon, Ebay, WooCommerce, Prestashop, Shopify, Squarespace e condividi sui tuoi canali social preferiti.',
      saleChannelSub: 'Tu vendi, noi spediamo!',
      droppshippingService:
        'Con Bdroppy vendi direttamente su Amazon, Ebay, WooCommerce, Prestashop, Shopify, Squarespace e condividi sui tuoi canali social preferiti.',
      earn_1: 'Guadagna fino a',
      earn_2: 'Guadagna fino a',
      earn_3: 'Guadagna fino a',
      earn_4: 'Guadagna fino a',
      earn_5: 'Guadagna fino a',
      earn_6: 'Guadagna fino a',
      earn_7: 'Guadagna fino a',
      earn_8: 'Guadagna fino a',
      reviews: {
        title1: 'Andrea',
        review1:
          'Sono davvero soddisfatta. Tempi di spedizione velocissimi e il prodotto era ben raffigurato sul sito! La vestibilità esattamente quella descritta e sono riuscita a scegliere facilmente la taglia corretta senza poi dover effettuare il reso.',
        title2: 'Monica',
        review2:
          'ESPERIENZA POSITIVA. Ho acquistato una borsa Guess tramite Bdroppy e mi sono trovata benissimo! Spedizione veloce, servizio clienti disponibile per le info e prodotto corrispondente al vero. Pagato con un super sconto, per fortuna ho scoperto questo sito.',
        title3: 'Addpaya',
        review3:
          'Per quanto mi riguarda bdroppy è un ottimo sito ho acquistato una giacca husky ad un prezzo veramente vantaggioso la spedizione è stata molto rapida io lo consiglio.',
        title4: 'Lorenzo',
        review4:
          'Volevo condividere la mia esperienza con bdroppy, li ho conosciuti tramite instagram e mi sono fidata ho acquistato già 2 volte da loro i prezzi sono davvero scontati di tantissimo anche il 50% in meno.',
      },
    },
    retargeting: {
      title_1:
        'il modo più facile per guadagnare grazie alla vendita di moda firmata. Vendi e guadagna [title_2] su ogni singola vendita',
      title_2: 'fino al 30%',
      head: "BDROPPY HAS A DEAL THAT'S TOO GOOD TO MISS OUT!",
      subtitle: 'Get 2 months for the [highlight] ',
      highlight: 'price of 1',
      footerTitle: 'Scelto da oltre [footerSpan] in tutto il mondo',
      footerSpan: '450.000 appassionati di moda',
      discoverProducts: 'Scopri tutti i prodotti',
      plans1: 'Start selling fashion online today!',
      plans2: 'THE PROMO WILL END IN:',
      category_title: "Cos'è BDroppy?",
      category_p:
        "Bdroppy è la prima piattaforma di social-ecommerce di moda firmata, dove puoi trovare i tuoi marchi preferiti con sconti fino all'80% su abbigliamento, calzature, borse e accessori",
      icon_label_1: 'Alti margini di guadagni',
      icon_label_2: '+120 marchi di moda',
      icon_label_3: 'Spedizioni rapide e sicure',
      createAccount: 'Crea il tuo account gratuito',
      brands_title:
        'Potrai scegliere tra migliaia di prodotti e [gradientText] e [gradientText2]',
      gradientText: 'oltre 120 marchi',
      gradientText2: 'moda firmata',
      CTA1: 'Activate your plan',
      CTA2: 'Find out more',
      video: 'https://youtu.be/Qu4h-zCU5ss?si=WVCI41U-DcPCr1aD',
      products:
        'Migliaia di prodotti di moda, infinite possibilità di business',
      shareAndEarn: 'Condividi. Vendi. Guadagna',
      li_1: 'Un catalogo con oltre 100 marchi di moda firmata',
      li_2: 'Prodotti firmati 100% originali',
      li_3: 'Spedizioni rapide e affidabili in tutto il mondo',
      li_4: 'Nessuna commissione sul venduto',
      li_5: 'Suggerimenti e consigli di vendita settimanali',
      li_6: 'Foto in alta definizione e materiale pubblicitario gratuito',
      li_register: 'Registrati subito',
      haveAChannel:
        'Con Bdroppy vendi direttamente su Amazon, Ebay, WooCommerce, Prestashop, Shopify, Squarespace e condividi sui tuoi canali social preferiti.',
      saleChannel:
        'Con Bdroppy vendi direttamente su Amazon, Ebay, WooCommerce, Prestashop, Shopify, Squarespace e condividi sui tuoi canali social preferiti.',
      saleChannelSub: 'Tu vendi, noi spediamo!',
      droppshippingService:
        'Con Bdroppy vendi direttamente su Amazon, Ebay, WooCommerce, Prestashop, Shopify, Squarespace e condividi sui tuoi canali social preferiti.',
      earn_1: 'Guadagna fino a',
      earn_2: 'Guadagna fino a',
      earn_3: 'Guadagna fino a',
      earn_4: 'Guadagna fino a',
      earn_5: 'Guadagna fino a',
      earn_6: 'Guadagna fino a',
      earn_7: 'Guadagna fino a',
      earn_8: 'Guadagna fino a',
    },
  },
  onboarding: {
    bsocial: {
      save: 'Save',
      payPalTitle: 'Paypal',
      payPalDescription1:
        'Insert your email of paypal account in order to activate paypal payment',
      payPalDescription2: 'Not a Paypal client yet?',
      payPalLink: 'Create an account here',
      paymentMethodTitle: 'Payment method',
      paymentMethodDescription: 'Select payment method',
      confirmationEmail: 'Confirmation Email',
      paypalEmail: 'PayPal email',
      generalSetting: 'General setting',
      generalSettingSubtitle: 'Update your list name, currency and language ',
      currency: 'Currency',
      language: 'Language',
      storeName: 'Shop name',
      ecreditInfo:
        'You have selected to receive your money as a credit into your purse. You can request the transfer of your earnings to your bank upon reaching 100€.',
      BDroppyCredit: 'Credit on BDroppy',
      storeNameWarning:
        'If you change the name of your store you will need to reshare your store link',
      storeNameWarningTitle: 'Warning',
      cancel: 'Cancel',
    },
    turnkey: {
      updateCatalog: 'Update catalog',
      updateCatalogTitle: 'You are moving connection',
      confirm: 'Confirm',
      websiteConf: 'Website configuration',
      nextStep: 'Next step',
      selectListSubtitle:
        "Select the list you want to attach to your website. If you don't have any list create your first list!",
      selectListInfo:
        ' If you select a list already connected with a channel you will change the connection with turnkey webstore',
      channelConnected: 'Canale collegato :',
      createList: 'Create list',
      cancel: 'Cancel',
      newList: 'New list',
      configurationDone: 'Configuration done',
      subtitleStep3: "Now we'll take care of everything!",
      email: 'You will receive an email when the website is ready',
      selectProducts: ' Select products to add on your list',
      browseCatalog: 'Browse catalog',
      goToSetting: 'Go to settings',
      manageList: 'Manage settings of your list',
      goBack: 'Go back',
      connectToShopify: 'Connect to Shopify',
      shopifySubtitle:
        'You will be redirect on Shopify in order to connect the channel. you need to wait a few minutes for the syn of products',
      insertShopName: 'Inserisci il nome del tuo negozio Shopify',
      connectChannel: 'Connect channel',
      titleModal: 'How to start',
      finishConfiguration:
        'Finish your configuration now, select the list for your website and start your business',
      selectList: 'Select list',
      steps: {
        step_1: '1 - Choose your list',
        stepDescripiton_1:
          'Select the list you want to connect with website. If you have no list create the first one. ',
        step_2: '2 - Connect to Shopify',
        stepDescripiton_2:
          'You will be redirect to channel section, insert your Shopify shop url and connect the list.',
        step_3: '3 - Tell us your preferences',
        stepDescripiton_3:
          "Now we'll take care of everything, you will receive an email when the website is ready",
        step_4: '4  - Manage your list',
        stepDescripiton_4:
          'Select products and manage the setting of your list, create markup rules',
        step_5: '5 - Start selling',
        stepDescripiton_5:
          "Now we'll take care of everything, you will receive an email when the website is ready. Start selling!",
      },
    },
  },
  formErrors: {
    required: '[fieldName] is required',
    validEmail: '[fieldName] must be a valid E-mail',
    length: '[fieldName] must be [len] character',
    minLength: '[fieldName] must have [min] characters at least',
    maxLength: '[fieldName] must have a maximum of [max] characters',
    invalid: '[fieldName] not valid',
    onlyNumber: '[fieldName] must be only numbers',
    minValue: '[fieldName] must be at least [minValue]',
    maxAmount: 'The amount requested is higher than your earnings', // Ritiro crediti bdroppy
  },
  voucher: {
    apply: 'Applica',
    voucherTitle: 'Hai un codice sconto?',
    voucherText:
      '[accedi] o [registrati] per utilizzarlo o per poter pagare in contrassegno',
    login: 'accedi',
    signup: 'registrati',
    voucher_applied_successfully: 'Voucher applicato con successo',
    voucher_not_applied: 'Voucher non valido',
    voucher_not_cumulative: 'Voucher non cumulabile',
    voucher_already_used: 'Voucher già usato',
    voucher_login_first: 'Login before using voucher',
    enter_voucher: 'Inserisci il codice',
  },
  cart: {
    title: 'Cart',
    goToCatalogue: 'Go to catalogue',
    empty: 'Your cart is empty',
    defaultIT: 'Vat will be updated after country selection',
    noItem: 'You have no item on your cart',
    browseCatalogue:
      'Browse our product catalogue and find out our products and the new arrivals of this week',
    productRemoved: 'Product removed from your cart',
    addToCart: 'Compralo subito',
    viewPricesPublic: "Vedi prezzi all'ingrosso",
    sellNow: 'Vendilo online',
    addToList: 'Aggiungilo alla lista',
    cart: 'Cart',
    productAdded: 'Product added to your cart',
    addedToList: 'Now select a list ',
    checkout: 'checkout',
    viewCart: 'View cart',
    selectSize: 'Select size',
    selectQuantity: 'Select quantity',
    continueShopping: 'Continue shopping',
    messageSize: 'If you want to add to import do not select size',
    productDetail: 'Product detail',
    viewSize: 'View avaibility',
    share: 'Share and earn',
    productRemove: 'Product removed',
    freeMessage: 'Sembra che tu non abbia ancora un piano attivo. Che aspetti?',
    catalog: 'Catalog',
    freeMessageTitle: 'Ops...',
    freeMessageSubtitle: 'Start selling and earning now!',
    ctaPlan: 'Activate a plan',
    warningNoSize: 'Select a size to continue',
    insertShopname: 'Setting social',
    insertDataChannel:
      'Non hai inserito correttamente tutti i dati per attivare il canale social',
    settingSocial: 'Inserisci il nome del tuo shop',
    goToSettings: 'Go to settings',
    noProductToShare:
      'You have no product to share, add one to twenty products and start selling',
    viewCatalog: 'Choose products',
    addProductToshare: 'Add product to your store',
    alertNoProduct: 'No product on your store',
    shareYourStore: 'Share',
    views: 'Views',
    likes: 'Likes',
    addToStore: 'Add to store',
    removeFromStore: 'Remove from store',
    shareAndEarn: 'Share and earn',
    shareAndEarnFree: 'Share and earn',
    youNeed: 'You are [number] away from free shipping',
    shippingFree: 'Free shipping fees',
    viewPrice: "Vedi prezzi all'ingrosso",
    cashback: 'Cashback',
    errorShipping:
      'The weight of the shipment exceeds the maximum weight that can be shipped to this country, please reduce the number of items or contact our assistance to request a shipping quotation.',
    steps: {
      checkout: 'Checkout',
      days: 'Days literal',
      goBack: 'Back to address',
      shippingAddress: 'Shipping address',
      goPayment: 'Go to payment',
      securePayment: 'Secure payment',
      continueShopping: 'Continue shopping',
      cart: 'My cart',
      or: 'or',
      sameProducts: 'Similar products',
      sameProductsSubTitle: 'You might also be interested',
      freeShipping: 'Free shipping',
      shippingNotes: 'Enter notes for the carrier',
      billingAddress: 'Billing address',
    },
  },
  public_catalog: {
    login: 'Login',
    register: 'Register',
    services: 'Services',
    brands: 'Brands',
    blog: 'Blog',
  },
  brands: {
    title: 'The best brands for your online business',
    text1: 'Over 100 top Italian and international fashion brands',
    text2:
      'Create your free account and access the dashboard to consult the entire catalogue and exclusive prices reserved for our resellers.',
    text3:
      'You can select the products to add to your personal catalogue and set the prices to',
    text4: 'get the most out of your online sales!',
  },
  menuItem: {
    home: 'Home',
    topBrands: 'Top brands',
    specialPromo: 'Black Friday',
    specialPromoLink: 'attributes=sales-reductions',
    brand_1: 'Birkenstock',
    brand_2: 'Love Moschino',
    brand_3: 'Atlantic Stars',
    brand_4: 'Tommy Hilfiger',
    brand_5: 'Calvin Klein',
    brand_6: 'Guess',
    brand_7: 'Philipp Plein',
    allproducts: 'View all product',
    moda: 'Moda',
    sexyShop: 'Sexy Shop',
    casa: 'Home',
    elettronica: 'Elettronica',
    giftBoxes: 'Gift boxes',
    viewAll: 'View all categories',
    viewAllProd: 'View all',
    shone: 'Shone Kids',
    man: 'Man',
    woman: 'Woman',
    children: 'Children',
    clothing: 'Clothing',
    sweatShirts: 'Sweatshirts',
    dresses: 'Dresses',
    jeans: 'Jeans',
    shirts: 'Shirts',
    leggings: 'Leggings',
    sweaters: 'Sweaters',
    tops: 'Tops',
    skirts: 'Skirts',
    tShirts: 'T-shirts',
    trousers: 'Trousers',
    jackets: 'Jackets',
    tracksuitPants: 'Tracksuit pants',
    rucksacks: 'Rucksacks',
    underwear: 'Underwear',
    swimwear: 'Swimwear',
    shoes: 'Shoes',
    flatShoes: 'Flat shoes',
    sneakers: 'Sneakers',
    laceUp: 'Lace up',
    mocassins: 'Mocassins',
    boots: 'Boots',
    ankleBoots: 'Ankle boots',
    decolletè: 'Décolletté',
    sandals: 'Sandals',
    wedges: 'Wedges',
    slipOn: 'Slip on',
    accessories: 'Accessories',
    sunglasses: 'Sunglasses',
    belts: 'Belts',
    necklaces: 'Necklaces',
    watches: 'Watches',
    wallets: 'Wallets',
    eyeglasses: 'Eyeglasses',
    scarves: 'Scarves',
    bags: 'Bags',
    crossBodyBags: 'Crossbody bags',
    travelBags: 'Travel bags',
    pochette: 'Clutch bags',
    shoulderBags: 'Shouldr bags',
    handBags: 'Handbags',
    briefCases: 'Briefcases',
    shoppingBag: 'Shopping bag',
    brands: 'Brands',
    reseller: 'Become a reseller',
    promoProduct: 'Promo',
    resources: 'Resources',
    ourProducts: 'Our products',
    ourServices: 'Our services',
    dropshipping: 'Dropshipping',
    aiChatbot: 'AI Chatbot',
    eFranchising: 'E-franchising',
    catalog: 'Tutto il catalogo',
    free: 'FREE',
  },
  wishlist: {
    title: 'Your wishlist ',
    remove: 'Remove',
    shareAndEarn: 'Share',
    buy: 'Buy',
    title_1: 'Add products',
    subtitle_1: 'Add products to your wishlist',
    title_2: 'Share your wishlist',
    subtitle_2: 'Share your wishlist with your friend',
    title_3: 'Cashback',
    subtitle_3: 'Receive 10% cashback on all products',
    noProducts: 'Your wishlist is empty',
    noProductToShare: 'Add products and start sharing',
    viewCatalog: 'View all products',
    addProducts: 'Add products on your wishlist and share it with your friends',
    addProductModal:
      'You have no product to share, add one to twenty products and start selling',
    alertNoProduct: 'No products on your wishlist',
    addProductsCTA: 'Add products',
    confirm: 'Confirm',
    changeName: 'Change name',
    yourWishlist: 'Your wishlist',
    wishlistName: 'Give your wishlist a name',
    wishlistMessage:
      'If you want to share with your friends your wishlist you need an account',
    login: 'Login',
    shareWishlist: 'Share wishlist',
  },
  privacy: {
    title: 'Privacy policy',
    p1: 'Dear Visitor/User, compliance with the Privacy Policy is particularly important to us.',
    p2: 'In particular, the “General Data Protection Regulation” (EU Regulation 2016/679, known by the English acronym “GDPR”) requires us to provide you with the following information on the processing of your Personal Data, pursuant to art. 13 of the aforementioned Regulation.',
    p3: 'The “Processing of Personal Data”, in simple words, is any operation concerning any “information relating to a natural person, identified or identifiable”. For example, your first and last name, or an e-mail address with a “username” that identifies you (e.g. mariorossi@….), is considered “Personal Data”, and the actions of collection, registration with us and use to send you a communication, are considered “Processing” operations; as well as (always for example) the communication of Personal Data to other organizations and storage.',
    p4: 'Our organization is defined as “Data Controller”, as a subject that establishes how and for what purposes to process information relating to natural persons. You, if “natural person to whom the Personal Data refers”, is defined as “Data Subject”, and you have the right to receive the following information about who we are, what Personal Data we process, why, how and for how long we process it, and what obligations and rights you have in this regard. If, on the other hand, you work on behalf of a private organization (e.g. partnerships, corporations, associations, etc.), the Data Subjects are the natural persons who use the Site, and/or the Platform, and/or use the Services under the authority of the same (e.g. you and/or your Workers). Information strictly related to the organization (e.g. tax code or VAT number) is not considered Personal Data.',
    p5: 'Depending on whether you are a simple Visitor or have requested one of our Services, we collect and/or need you to provide us with certain Data, which are necessary for us to allow you to browse the Site and/or to receive answers to your requests and/or allow you to use the Platform and our Services; in the first case (i.e. when you simply visit the Site) it is generally information that does not allow you to be identified (and therefore we will only process “Navigation Data”). We specify that our Company is the Data Controller only with reference to the purposes specified in the following grid. With reference, instead, to the Personal Data that you will communicate to third-party managers of sites and platforms connected to the Platform during the use of the Services (eg marketplace managers), we invite you to consult the terms and conditions and privacy policies applied by these managers.',
    p6: 'With reference to the Processing of personal data of your customers that we will process on your behalf during the provision of the Services, the Company does not play the role of Data Controller, but of Data Processor by virtue of the contractual documents that it has accepted or will accept at the time of purchasing the BDroppy Services provided by the Company. The website of the Italian Data Protection Authority contains further useful information to better understand the topic (see e.g.: https://www.garanteprivacy.it/web/garante-privacy-en).',
    p7: 'The definitions of the terms and expressions used are contained in the Glossary at the bottom of the page. For anything not expressly defined herein, please refer to the definitions contained in the Terms and Conditions; in case of possible conflict between definitions, for the purposes of this Privacy Policy the definitions of the Glossary (at the bottom of the page) prevail over those contained in the General Terms and Conditions.',
    p8: '“Supervisory Authority”: means the reserved area accessible from the Site to which it is necessary to register to purchase the Services. ',
    p9: '“Supervisory Authority”: the independent public authority established by a State of the European Union, or by the European Union itself, in charge of supervising the application of the Privacy Law (for Italy, the Guarantor for the Protection of Personal Data, http://www.garanteprivacy.it). ',
    p10: '“Authoritỳ”: body or organization, public or private, with administrative, judicial, police, disciplinary and supervisory powers. ',
    p11: '“Authorized”: the natural person, placed under the direct authority of the Data Controller, who receives from the latter instructions on the Processing of Personal Data, pursuant to and for the purposes of art. 29 of the GDPR. ',
    p12: '“Privacy Code”: Legislative Decree no. 196/2003 and subsequent amendments and/or additions (in particular by Legislative Decree no. 101/2018).',
    p13: '“Committee” or “EDPB”: the European Data Protection Board, established by art. 68 of the GDPR and governed by Articles. from 68 to 76 of the GDPR, which replaces WP29 from 25/5/2018.',
    p14: '“Communication”: “the giving knowledge of personal data to one or more specific subjects other than the data subject, the representative of the data controller in the territory of the European Union, the manager or his representative in the territory of the European Union, the persons authorized, pursuant to Article 2-quaterdecies, to process personal data under the direct authority of the owner or manager, in any form, also through their availability, consultation or interconnection” (as defined in Article 2-ter, paragraph 4, letter a of the Privacy Code).',
    p15: '“Contract”: agreement stipulated with the Customer User, through acceptance, by the latter, of the Terms and Conditions.',
    p16:
      '“Cookies”: short fragments of text (letters and / or numbers) that allow the web server to store information on the browser to be reused during the same visit to the site (session cookies) or later, even after days (persistent cookies). Cookies are stored, based on user preferences, by the individual browser on the specific device used (computer, tablet, smartphone). The following categories are considered:\n' +
      '\n' +
      'Technical cookies: these cookies are essential for the proper functioning of the site and are used for the sole purpose of “carrying out the transmission of a communication over an electronic communications network, or to the extent strictly necessary for the provider of an information society service explicitly requested by the subscriber or user to provide this service” (see art. 122, c. 1, of the Privacy Code).\n' +
      'Analytical cookies: these are cookies used to collect and analyze traffic and use of the site anonymously. These cookies, while not identifying the user, allow, for example, to detect if the same user returns to connect at different times. They also allow you to monitor the system and improve its performance and usability. Disabling these cookies can be done without any loss of functionality.\n' +
      'Profiling cookies: these are persistent cookies used to identify (anonymously or not) the user’s preferences and improve his browsing experience.\n' +
      'Third-party cookies (analytical and / or profiling): these are cookies generated by organizations not belonging to the Site, but integrated into parts of the Site page. Think, for example, of Google “widgets” (e.g. Google Maps) or “social plugins” (Facebook, Twitter, LinkedIn, Google+, etc.).',
    p17: '“Navigation Data”: are the data that the computer systems and software procedures used to operate the site acquire, during their normal operation, and whose transmission is implicit in the use of Internet communication protocols. This information is not collected to be associated with identified interested parties, but by their very nature could, through processing and association with data held by third parties, allow users to be identified. This category of data includes IP addresses or domain names of the computers used by users who connect to the site, addresses in URI (Uniform Resource Identifier) notation of the requested resources, the time of the request, the method used to submit the request to the server, the size of the file obtained in response, the numerical code indicating the status of the response given by the server (successful, error, etc.) and other parameters relating to the operating system and the user’s computer environment. These data, necessary for the use of web services, are also processed for the purpose of: obtaining statistical information on the use of the services (most visited pages, number of visitors per time slot or day, geographical areas of origin, etc.); check the correct functioning of the services offered.',
    p18: '“Personal Data”: “any information relating to an identified or identifiable natural person (“data subject”); an identifiable natural person is one who can be identified, directly or indirectly, with particular reference to an identifier such as a name, an identification number, location data, an online identifier or to one or more characteristic elements of his physical, physiological, genetic, mental, economic, cultural or social identity”, as defined by art. 4, subparagraph 1, n. 1, of the GDPR).',
    p19: '“Data” or “Data”: one or more of the categories indicated as Personal Data.',
    p20: '“Recipient”: “the natural or legal person, public authority, service or other body that receives communication of personal data, whether or not it is a third party”, as defined by art. 4, subparagraph 1, n. 9, of the GDPR. ',
    p21: '“Dissemination”: “giving knowledge of personal data to indeterminate subjects, in any form, including by making them available or consulting” (as defined in Article 2-ter, paragraph 4, letter.b of the Privacy Code). ',
    p22: '“GDPR”: EU Regulation 2016/679 “on the protection of individuals with regard to the processing of personal data, as well as on the free movement of such data and repealing Directive 95/46 / EC (General Data Protection Regulation)”.',
    p23: '“Data subject”: “identified or identifiable natural person”, as defined by art. 4, paragraph 1, n. 1, of EU Regulation 2016/679 (so-called “GDPR”). ',
    p24: '“Limitation”: “the marking of personal data stored with the aim of limiting their processing in the future”, as defined in art. 4, subparagraph 1, n. 3, of the GDPR. ',
    p25: '“Regulations” or “Regulations”: one or more of the sets of rules indicated, in this Act, as Privacy Policy and Applicable Law. ',
    p26: '“Applicable Legislation”: any provision, of any rank, belonging to Italian or European Union law, in any way applicable to the Site and / or the Contract.',
    p27: '“Privacy Law”: EU Regulation 2016/679 (“GDPR”), Legislative Decree 196/2003 and subsequent amendments and / or additions (“Privacy Code”), as well as the measures adopted by the Supervisory Authority in execution of the tasks established by the GDPR and the Privacy Code, and the further applicable legislation, of any rank, including the opinions and guidelines drawn up by the Committee. ',
    p28: 'Platform: the digital dropshipping platform made available through the Site. ',
    p29: 'Privacy Policy: this information on the processing of personal data for the management of the Site. ',
    p30: 'Professionals: the subjects who carry out the profession of psychologist and / or researcher in the field of psychotherapy using the Platform on the basis of specific agreements with the Company.',
    p31: '“Profiling”: “any form of automated processing of personal data consisting in the use of such personal data to evaluate certain personal aspects relating to a natural person, in particular to analyze or predict aspects concerning the professional performance, economic situation, health, personal preferences, interests, reliability, behavior, location or movements of said natural person”, as defined in art. 4, subparagraph 1, n. 4, of the GDPR. ',
    p32: '“Publication”: the action by which the Data Controller communicates information on the Site, without the implementation of procedures that require the Visitor to view it.',
    p33: '“Responsible”: “the natural or legal person, public authority, service or other body that processes personal data on behalf of the data controller”, as defined by art. 4, subparagraph 1, n. 8, of the GDPR. ',
    p34: '“BDroppy Service”: any service provided by the Company to its Client Users through the Platform. ',
    p35: '“Site”: web pages displayed through www.bdroppy.com, including subdomains. ',
    p36: '“Company”: the company IDT S.p.A., with registered office in Via Quittengo 35, 10154 Torino (TO), C.F. e P.IVA 10010450012, registered in the Turin Register of Companies, REA number TO-1098199',
    p37: '“Terms and Conditions”: also abbreviated as “GTC”, available on the Page of the Site [insert link] govern the use of the Site and the provision of the Platform and Services. ',
    p38: '“Third”: “the natural or legal person, public authority, service or other body that is not the data subject, the data controller, the data processor and the persons authorized to process personal data under the direct authority of the owner or manager”, as defined by art. 4, subparagraph 1, n. 10, of the GDPR.',
    p39: '“Data Controller”: “the natural or legal person, public authority, service or other body which, individually or together with others, determines the purposes and means of the processing of personal data”, as defined by art. 4, subparagraph 1, n. 7, of the GDPR.',
    p40: '“Processing” means “any operation or set of operations, performed with or without the aid of automated processes and applied to personal data or sets of personal data, such as collection, recording, organization, structuring, storage, adaptation or modification, extraction, consultation, use, communication by transmission, dissemination or any other form of making available, the comparison or interconnection, limitation, cancellation or destruction”, as defined by art. 4, subparagraph 1, n. 2, of the GDPR.',
    p41: '“User”: means, without distinction, Registered Users and Customer Users. ',
    p42: '“Client User”: the natural person who purchases any BDroppy Service of the Company from the Reserved Area and therefore uses the Service and the Platform. ',
    p43: '“Registered User”: the natural person who registers in the Reserved Area. ',
    p44: '“Visitor”: the natural or legal person who uses a device and browses, through the Internet, on the public pages of the Site. ',
    p45: '“WP29”: the Working Group for the Protection of Individuals with regard to the Processing of Personal Data, established pursuant to art. 29 of Directive 95/46/EC, whose tasks are set out in art. 30 of Directive 95/46/EC and art. 15 of Directive 2002/58/EC.',
    pleaseNote:
      'PLEASE NOTE: \n' +
      '\n' +
      'the information herein concerns exclusively the processing carried out on the Personal Data collected by us as a result of the provision of the Site, the Platform and the Services. In the event that you enter into a relationship with the Company other than the above, including relationships that provide for the provision of sites, platforms or services other than those regulated herein, different contractual terms and different privacy policies will be applied. 2. this Privacy Policy is in force since August 2021; we reserve the right to modify its content, in part or completely, also as a result of changes in the Privacy Policy; we will publish the updated version of the Privacy Policy on the Site and from that moment it will be binding: you are therefore invited to visit this section regularly.\n' +
      'We do not intentionally collect personal information relating to natural persons who, according to their national law of origin, are without the legal capacity to act for the purpose of entering into contracts, except for requests relating to minors made by the subjects who exercise parental authority or custody over the minors in question. In the event that information on these subjects is recorded, we will delete it in a timely manner, at the request of the interested party or of those who exercise authority over it.',
    glossary: 'Glossary',
    q1: 'Who are we (“Data Controller”)?',
    a1: 'IDT S.p.A., with registered office in Via Quittengo 35, 10154 Torino (TO), C.F. e P.IVA 10010450012, registered in the Turin Register of Companies, REA number TO-1098199.',
    q2: 'What are the categories of Data Subjects to whom this information is addressed?',
    a2:
      'Visitor: the natural person who uses a device and browses, through the Internet, on the public pages of the Site. \n' +
      '\n' +
      'Registered User: the natural person who registers in the Reserved Area. \n' +
      '\n' +
      'Customer User: the natural or legal person who purchases any BDroppy Service of the Company from the Reserved Area and therefore uses the Platform and the Service purchased.',
    q3: 'What categories of Personal Data do we process?',
    a3:
      'Navigation Data and “Common” Personal Data (name and surname, e-mail address, telephone number, tax code, VAT number, as well as other data that you may provide us, for example through the forms or contact details of our organization available on the Site), to the minimum extent necessary to achieve each of the Purposes indicated below.\n' +
      '\n' +
      'Please do not include any “sensitive” information in the texts of communications and in the description fields of our online forms (sensitive information is considered personal data revealing racial or ethnic origin, political opinions, religious or philosophical beliefs, or trade union membership, as well as genetic data, biometric data and data relating to the health or sex life or sexual orientation of the person).',
    q4: 'What is the origin of your Personal Data?',
    a4: 'As a rule, it is you yourself who transmit them, or another natural person belonging to the organization for which you work authorized for the purpose.',
    q5: 'Why do we process Personal Data (Purposes) and on what is the Basis of the Processing (Legal Basis) of each category of Data, and what is the Retention Period?',
    a5: '',
    q6: 'Clarifications on the Maximum Retention Period',
    a6: 'Your Personal Data will be processed for the maximum periods indicated above for the respective related processing purposes, unless the Applicable Legislation requires us to keep them for a longer period or allows it to protect our rights and / or legitimate interests.',
    q7: 'To whom do we communicate the Data (Categories of Recipients)?',
    a7:
      'To the minimum extent necessary to achieve each of the Purposes, on the basis of the Applicable Regulations and / or a contractual agreement with the Data Controller, to:\n' +
      '\n' +
      'subjects necessary for the execution of activities connected and consequent to the management of the Site, the management of the Platform and the provision of the Services, who act as Data Processors (e.g. IT service providers, etc.);\n' +
      'subjects necessary for the execution of activities connected and consequent to the provision of the Services, who act as Data Processors or as independent Data Controllers (e.g. suppliers of IT, banking, insurance, shipping and transport services, commercial agency, accounting, tax, tax, legal, etc.);\n' +
      'other persons authorized by us (e.g. our workers), committed to confidentiality or recipients of a legal obligation to confidentiality;\n' +
      'public organizations and Authorities, if and to the extent that this is required by the Applicable Legislation or by their orders, or for the exercise, assessment and / or defense of a right in court.\n' +
      'The Data Controller does not carry out the Dissemination of Personal Data, except in the event that it is required, in accordance with the law, by Authorities, information and security bodies or other public entities for purposes of defense or security of the State or prevention, detection or repression of crimes. \n' +
      '\n' +
      'The Data that you communicate to third-party operators of sites and platforms connected to the Platform during the use of the Services are to be understood as communicated directly by you to these managers.',
    q8: 'Do we transfer Personal Data outside the European Union?',
    a8:
      'Yes, for the provision of the Site and the Platform, the Company uses, in addition to subjects located in the territory of the European Union, also subjects located outside this territory, with particular reference to the storage of the servers on which the Personal Data of Visitors / Users are stored (located in Cardiff, United Kingdom). \n' +
      '\n' +
      'The Data Controller ensures that the transfer of non-EU data takes place in accordance with the applicable legal provisions and that the transfer is carried out to subjects (third countries and / or international organizations) for which there is an adequacy decision of the European Commission pursuant to Article 45 GDPR, or by stipulating, where necessary, agreements that guarantee an adequate level of protection and / or adopting the standard contractual clauses provided by the Commission European, and in any case in compliance with the other guarantees or derogations provided for in Chapter V of EU Regulation 2016/679 (GDPR).\n' +
      '\n' +
      'If you do not agree that your Personal Data may be transferred to non-EU countries, we invite you not to enter into any Contract with the Company and to cease using the Site and the Platform.',

    q9: 'Does the Site use Cookies?',
    a9: 'Yes. To learn more and to view our policy in this regard, you can consult the Cookie Policy.',
    q10: 'Are you obliged to provide us with Personal Data?',
    a10: 'Due to the operation of the Internet, it cannot refuse the communication of Navigation Data; there is no refusal to communicate some Personal Data (such as the IP address of your device).',
    q11: 'What happens if you refuse to communicate your Data?',
    a11: 'If you refuse to communicate Personal Data for the contractual purposes indicated above in numbers 2, 3 and 4, we will not be able to establish the contractual relationship and fulfill your request or provide the Service.',
    q12: 'What communications do we send you?',
    a12: 'We will only send you communications necessary for the performance of the Contract, based on the applicable contractual purpose among those indicated above. For example, we will communicate with you to respond to your general request (Purpose 2), or we may send you notifications to inform you of issues related to access to the Reserved Area, or information concerning the sales operations managed by you in dropshipping mode thanks to the Platform and as a result of subscribing to the Services (Purposes 3 and 4).',
    q13: 'What rights do you have as an “Data Subject”?',
    a13:
      'You, as the person to whom the data refer (“Data Subject”) have the right to: \n' +
      '\n' +
      'access the data held by the Data Controller, and to request a copy, except in the event that the exercise of the right infringes the rights and freedoms of other natural persons; \n' +
      'request the correction of any incomplete or inaccurate data; request the deletion of data, without prejudice to the exclusions or limitations established by the Applicable Regulations (e.g. Article 17 § 3 GDPR); \n' +
      'request the Limitation of processing, where the conditions are met and without prejudice to the exclusions established by art. 18 § 2 GDPR; lodge a complaint with the Guarantor for the Protection of Personal Data (in Italy, www.garanteprivacy.it), or with the Guarantor Authority of the EU State in which he habitually resides or works, or of the place where the alleged violation occurred. \n' +
      'The exercise of the above rights may also be delayed, limited or excluded in the cases provided for by art. 2-undecies d. lgs. 196/2003.',
    q14: 'Who can you contact with questions or to exercise your rights?',
    a14: 'You can contact the Data Controller for questions concerning the processing of your Personal Data and to exercise your rights by sending an email to the address info@bdroppy.com, or by post to the address: IDT SpA, Via Quittengo 35, 10054 Torino (TO), Italy.',

    purpose: 'Purpose',
    categories: 'Categories of Personal Data',
    legal: 'Legal Basis',
    retention: 'Retention Period',
    analyze:
      ' Analyze the traffic on the Site (eg detect the most visited\n' +
      '                    pages, the number of visitors per time slot or day, the\n' +
      '                    geographical origin, the average connection time, the\n' +
      '                    browsers used, the origin of the visitor – from search\n' +
      '                    engines or other sites -, phrases and words searched etc.)\n' +
      '                    to understand how it is used and manage it, optimize and\n' +
      '                    improve it, or even just for statistical purposes; solve\n' +
      '                    operational problems (e.g. anomalies in page loading);\n' +
      '                    perform monitoring activities to repel and/or prevent cyber\n' +
      '                    attacks and fraud.',
    navigationData:
      'Navigation Data, anonymous information (which does not allow us to trace your identity) and Common Personal Data (e.g. full IP address)',
    theNeed:
      'The need to make the Site available in accordance with the Terms and Conditions (art. 6.1.b GDPR)',
    oneWeek: '1 week from the date of your last access to the Site.',
    satisfy:
      'Satisfy the requests that you want to transmit to us using the contact details on the Site.',
    common: 'common',
    theNeed_2:
      'The need to adopt pre-contractual measures at your request (art. 6.1.b GDPR)',
    forAmaximum: 'For a maximum of 2 years from your last request.',
    provide: 'Provide you with access to the Reserved Area',
    providing: 'Providing BDroppy Services',
    request:
      'For a maximum of 10 years from your request to cancel the Service and your account.',
  },
  terms: {
    title: 'Terms and conditions',
    p1:
      'IDT S.p.A., having its registered office in via Quittengo 35 (Turin), C.F.-P.IVA 10010450012 hereby represented by its pro tempore legal representative (hereinafter, “IDT”), created and is the owner of a website for online sale of products and for the supply of the dropshipping service, whose domain is www.bdroppy.com (hereinafter “DB Main Domain”) \n' +
      '\n' +
      'IDT wants to offer users regularly registered on the DB Main Domain (hereinafter, “User”), under regular price payment (hereinafter, “Price”), a membership service giving the User the opportunity to sell online IDT products supplied in dropshipping (hereinafter, the “Service”) listed in the catalogue (hereinafter, the “Catalogue”) through the user’s online shop (therefore provided through own plugins for the automatic exchange of catalog and order data) or through a ready-to-use e-commerce with domain owned by the User created by IDT and integrated with the dropshipping service provided by the latter (hereinafter “User Domain”). \n' +
      '\n' +
      'In light of the above,',
    t1: 'THE FOLLOWING IS AGREED',
    t2: '1. Cost of the service\n',
    t3: '2. Service content',
    t4: '3. Orders and Shipments',
    t5: '4. Product payment terms',
    t6: '5. Post-sales and product return policy',
    t7: 'Social',
    t8: 'Turnkey website',
    t9: 'Hosting',
    t10: 'Product categories',
    t11: 'Data transmission',
    p4: 'The User’s request to activate the Service amounts to a proposal. The User shall register on the DB Main Domain, within the manner and the terms established in Annex A, choosing the desired Service and accepting the conditions of the present contract by ticking the acceptance box, also in relation to the clauses under articles 1341 and 1342 Italian Civil Code. It is understood that the registration is subject to the electronic acceptance through the ticking of the present contract terms and conditions. The User’s proposal will be deemed to be accepted, and thus the contract concluded, at the moment of the Service activation by IDT, which will happen upon verification of the User’s regular registration on the DB Main Domain and the success of the Price payment, as detailed in Annex A. By registering, requesting the Service activation and accepting by clicking on the acceptance button, the User declares to have read and to accept all contents in the present contract also in relation to the provisions under articles 1341 and 1342 Italian Civil Code. It is understood that the present contract between the User and IDT will be concluded only in digital form by accepting the present conditions through the electronic point-and-click procedure by the User on the DB Main Domain.\n',
    p4_1: 'The User may proceed with the Price payment through the modes indicated in Annex A. The User undertakes to adopt all necessary measures to ensure the successful outcome of the payment. In the event that the payment of the amounts due to IDT is not successful, IDT reserves the right to suspend the Service supply until the moment of the effective payment.\n',
    p4_2: 'The User is not bound by any non-competition obligation and therefore is entitled to directly or indirectly handle competitor products other than IDT’s. The User does not enjoy any exclusive rights for IDT’s product. It is understood that IDT is free to handle the online and offline sale with end customers directly or through agents, other partners or intermediaries. In any case, IDT may not be considered responsible for products, sold by the User on his/her own User Domain, which are not listed in the Catalogue proposed by IDT\n',
    p4_3: 'The User may use trademarks owned by IDT or by third parties with a mere descriptive function necessary to indicate the industrial origin of the product and ensure its originality. IDT does not authorize the use of logos, symbols or other distinguishing marks exclusively owned by IDT or by third parties. It is understood that IDT cannot be deemed responsible for the eventual misuse of such logos, symbols, marks or other distinguishing signs by the User.\n',
    p4_4: 'The User shall hold IDT harmless and shall indemnify it from any kind of claims, such as damages, liability, costs, burdens and expenses claims, including eventual legal fees, deriving from any User’s non-compliance with obligations under this contract.\n',
    p4_5: 'The Service has a minimum duration of 1 or 12 months and starts running from the date of its activation by the User. The Service will automatically be renewed for the same period. It is understood that the User will have to pay the current Price at the time of each renewal.\n',
    p4_6: 'It is understood that IDT, in any case and at any time, may terminate the present contract and interrupt the Service, by means of an e-mail notice to the address provided by the User, who will not have the right to any compensation or reparation. In case of termination of the contract by IDT, the Price eventually paid for the period during which the Service will not be used will be reimbursed to the User.\n',
    p4_7: 'The Parties reciprocally ensure the respect of any norms related to personal data process. The personal data provided will be processed exclusively for the pursuance of contractual purposes. By registering and accepting the present contract as outlined above, the User gives his/her consent in order for IDT to process his/her personal data, provided at the time of registration and of the Service request, and to transfer the User via e-mail any communications relating to the execution of the present contract, to the Service and to the promotion of the Catalogue products. The User, as owner of the data of his/her customers, appoints IDT responsible for the treatment with reference to the data of the end users that are transmitted to him in order to perform the Service, by signing the contract referred to in the Annex “Designation of the data processing manager”.\n',
    p4_8: 'The sales between IDT and the User will be subject to IDT’s general sale conditions provided by the present contract.\n',
    p4_9: 'The present contract is governed by Italian law.\n',
    p4_10:
      'All disputes arising out of or in connection with the present contract, both contractual and non contractual, shall be exclusively and finally settled by the competent Court of the place where IDT has its registered office\n',
    p4_11:
      'The present contract repeals and replaces any other precedent written or verbal agreement, eventually entered into force between the parties on the matter covered by the contract.\n',
    p4_12:
      'Any amendment or integration shall be made in writing, otherwise they should be void.\n',
    p4_13:
      'The present contract cannot be transferred, in whole or in part, unless previously agreed in writing by the parties.\n',
    p4_14: 'IDT’s Dropshipping service is not for resale to third parties.\n',
    p4_15:
      'In the event of non-compliance with the present contract by the other party, the failure to exert a remedy or a right shall not constitute waiver to exert such remedy or right in the future.\n',
    p4_16:
      'The Whereas and the Annexes shall be considered a constitutive part of the present Terms of BDroppy.\n',
    p4_17: 'The service is not refundable.\n',
    p4_18:
      'Depending on the country in which it operates, the client may have to open a VAT position to fulfill the tax obligations of their country. IDT is not responsible in case of non-compliance.',
    p5: 'The Dropshipping service can be activated as follows:\n',
    p5_2: 'SOCIAL – 1 integration (1 list and 1 channel) 29€/month – 290€/year\n',
    p5_3: 'PLUGIN – 1 integration (1 list and 1 channel) 99€ /month – 990€/year\n',
    p5_4: 'PLUGIN+ – 3 integrations (3 lists and 3 channels) 199€ /month – 1990€/year\n',
    p5_5: 'The Turnkey Site service can be activated in the following ways:\n',
    p5_6: 'The price of the turnkey site will be determined by BDroppy based on the customer’s needs. Acceptance of the quote and simultaneous payment of the agreed site price with the reference salesperson is considered acceptance of these Terms and Conditions and the consequent start of the contract with Bdroppy. The service will automatically renew annually\n',
    p5_7: 'The cost of the service is non-refundable by the European Directive on Consumer Rights.\n',
    p5_8: 'The service is activated within 24 hours after receipt of payment.\n',
    p5_9: 'The User can pay for the service by credit card (Stripe) or Paypal\n',
    p5_10:
      'Depending on the plan chosen, the service will last for 1 or 12 months.\n' +
      'The User can change the subscription plan of the service directly from his profile in the “Plans and Prices” section.\n' +
      '\n' +
      'The Service will be renewed automatically for the same period unless canceled by the User, cancellation to be sent at least 1 month before the expiry of the Service by email. It is understood that the User will have to pay the Price in effect at the time of each renewal. In the event that the User cancels in the manner and within the deadline set above, he/she can choose whether to completely disable the Service or keep the e-commerce by ceasing to use the dropshipping service offered by IDT by paying, in this case IDT S.p.A. within 7 days will delete the domain from its servers. The User is therefore asked to address the domain to the new server within these times.',
    p6: 'Dropshipping\n',
    p6_1: 'Once one of the Dropshipping plans proposed for the type of service requested is activated, the User can select the products for one or more lists, consequently integrate them into the selected channel (s) or download the files in the desired format: (XLSX, CSV, XML, or JSON) in the “Manage import lists” area.\n',
    p6_2: 'The data provided on the selected product are:\n',
    p6_3: 'Brand\n',
    p6_4: 'Product code (SKU)\n',
    p6_5: 'Barcode\n',
    p6_6: 'Made in\n',
    p6_7: 'Available stock\n',
    p6_8: 'Category\n',
    p6_9: 'Season\n',
    p6_10: 'Gender\n',
    p6_11:
      'Description in 20 languages (Italian, English, French, German, Spanish, Romanian, Portuguese, Polish, Dutch, Slovak, Hungarian, Swedish, Estonian, Czech, Finnish, Danish, Bulgarian, Lithuanian and Greek)\n',
    p6_12: 'Volumetric weight Link to 3 product photos\n',
    p6_13: 'Italian retail price (VAT included)\n',
    p6_14: 'Selling price (VAT excluded)\n',
    p6_15: 'Suggested price (VAT included)\n',
    p6_16:
      'The price of the products is the same as the one in the “Search products” section of BDroppy under Cost (VAT excluded). Bdroppy.com does not retain any percentage on the sale of the products.\n',
    p6_17:
      'In order to protect the collaboration with the different brands, Bdroppy recommends selling prices (suggested_price) available in the different formats provided (xlsx, csv, xml and json) and suggests not to drop below 30% of net margin. IDT provides advertising material useful for sponsoring the products on sale, however the use of a logo or registered trademark is prohibited without the authorization of the owner of the trademark itself. It is understood that IDT cannot be held responsible for any incorrect use of these logos, symbols, brands or other distinctive signs by the User. Technical management is entirely entrusted to the User. IDT provides assistance within 48h via e-mail, ticket and chat for information and problems related to the service offered. For assistance with the plugins, the user will be required to provide complete access information (admin and ftp) to carry out a correct diagnosis and resolution of the verified problems. In the event that interventions are requested to the BDroppy staff, for example installation and setting of the plugins or resolutions of problems not related to the operation of the plugins provided by BDroppy or in general of functions not included in the BDroppy offer, the user will be requested a payment of 199 € for extra intervention required. In the case of a free role and therefore in the absence of subscription to a dropshipping plan or in the absence of renewal of one of the subscription services of your choice, the previously selected catalogues will be removed within 72h of the creation of the catalogue/expiration of the service.',
    p7: 'All Bdroppy plugins provide automatic transmission of orders received on the user’s shop. \n',

    p7_2: 'It is also possible to place the order in manual mode by accessing the Orders section of the Bdroppy Dashboard and completing the order procedure. In the case of using the File, orders will have to be created manually on BDroppy.\n',

    p7_3: 'The User agrees to place the order on Bdroppy, only once the purchase has been made and confirmed by his/her end users on his/her e-shop. This order is considered in a “booked” status and awaiting payment. Any changes/cancellations are accepted only if the order is in the “booked” status. Once the receipt of the payment has been confirmed, the order is processed and passed on to the logistics processing, therefore it is no longer possible to make changes/cancellations. In the event that the shipment should return to sender, for an incorrect address or for non-acceptance by the end user, a credit note will be provided and consequent credit net of shipping costs. With Bdroppy’s Dropshipping service, the User can choose whether to:\n',

    p7_4: 'ship orders to final customers via IDT courier* by activating the option “Ship to customer” in the Catalogue Settings\n',

    p7_5: 'independently manage the packing and shipping of the orders of his/her end customers: in this case it is necessary to make cumulative orders, to be received in your logistics through IDT courier or own courier by activating the “Ship to me” option in the Catalogue Settings\n',

    p7_6: '*IDT delivers the products directly to the end customer in the countries and at the costs indicated in the “Shipping fees” section inside the Dashboard. Packages sent to the end customer do not contain any reference to Bdroppy.com. Shipping costs are always to be paid by the User. For shipments to non-EU countries, customs duties and charges may apply depending on the regulations of the country of destination of the goods. The User is invited to contact their local customs office for further information.\n',

    p7_8: 'Product shipments from partner warehouses\n',
    p7_9: 'In order to offer an ever-growing assortment, BDroppy uses official and certified partner warehouses in Italy.\n',
    p7_10:
      'Shipping products from partner warehouses may require a few extra days of preparation, lengthening the delivery time provided in the “Shipping Costs” table.\n',
    p7_11:
      'How can I tell that I am purchasing a product shipped from a long distance?\n',
    p7_12:
      'In the product sheet you will read the phrase: -Partner stock product- and this means that your product will be available just waiting a few extra days for delivery.\n',
    p7_13:
      'In the case of orders consisting of prompt delivery products and products from partner warehouses, the delivery time may be different from those in the Shipping Costs table, which is why we bear the shipping costs from the partner warehouses to our own warehouses and not burden the User’s costs.\n',
    p7_14: 'Can I return items purchased with this type of shipping?\n',
    p7_15:
      'Sure. If your order consists of items from different warehouses, you can return them in the same package. For information and support you can contact our customer care by opening a ticket here https://bdroppy.kayako.com/it/conversation/new or by sending an email to contact@bdroppy.com',
    p8:
      'Once the end customer has purchased the product on the User’s e-shop, the User must then create the order (or the order will be automatically generated) on the BDroppy platform, by entering his/her billing information and the shipping details of the end customer (or another address where he/she wishes to receive the goods). If payment is not made within 24 hours, then the order expires.\n' +
      '\n' +
      'Orders can be paid by credit card (Stripe)or Paypal. The order will be automatically confirmed in case of existing credit on the User’s profile. If the credit does not cover the entire cost of the order, then the payment of the missing amount will be required. An invoice is issued for any payment made, both for single order or for multiple orders, the User can download it from his/her profile page. For Italian customers: the electronic invoice will be duly sent to the SDI who will arrange for it to be delivered to your electronic inbox (certified e-mail address or recipient code). Invoices are also available on the User’s BDroppy profile, yet they are not valid for tax purposes.',
    p9: 'The User can request a return within 20 days of receiving the order, for the following reasons: if he/she dislikes the product; if the product is too big/small, damaged, does not correspond to the product ordered, or if it is not actually in the package, etc. To start the return request, it is necessary to follow these instructions:\n',

    p9_1: 'In order to make a return on Bdroppy, log in to your profile and go to ORDERS > My orders.\n',
    p9_2: 'Idendify the order for which you wish to make a return request.\n',
    p9_3: 'To be able to make a return request, the order status must be DISPATCHED.\n',
    p9_4: 'Under the “Actions” column, you will have to click on the three dots and a drop-down menu will appear.\n',

    p9_5: 'Then click on REQUEST RETURN, enter the quantity and the reason for the return.\n',
    p9_6: 'Then click on Send request.\n',
    p9_7: 'All your return requests will be visible in the section Orders > My returns.\n',

    p9_8: 'IDT reserves the right not to refund in the following cases:\n',

    p9_9: 'The product is damaged or the original packaging (shoe box, sunglasses case, dust-proof bag) is missing or damaged.\n',
    p9_10:
      'Return code and/or order number are missing\n' +
      'Unauthorized or after return deadline\n' +
      'The shipping, return costs and customs duties are to be paid by the User unless otherwise instructed. Also in the case of damaged or non-compliant products, a return request must be made as indicated above. The damage must be described in detail and photos must be attached demonstrating its extent within and no later than 20 days from receipt of the order. Please send all details to the appropriate contact form. The refund is issued in the form of a credit loaded on the User’s profile within a maximum of 10 working days from the product reception and is visible in the little piggy bank in the top right corner of the account page. The credit is automatically deducted when a new order is placed. The credit is available for 2 years following the issuance of the credit note. Bdroppy does not exchange goods. It is necessary to make a return request for the product that the User wishes to return and create a new order deducting any credit charged on the User’s profile.\n',
    p9_11:
      'Orders that are returned to the sender due to non-delivery to the recipient (recipient not found after various delivery attempts, rejection of the goods by the recipient) will be refunded according to the methods already described above, but the cost for the return of the goods and the customs duties applied will be charged to the User, according to the following methods:\n' +
      '– orders returning from Extra-EU countries (except UK) – flat rate payment of €45 + customs duties\n' +
      '– orders returning from the UK – flat rate payment of €30 + customs duties\n' +
      '– orders returning from EU countries excluding Italy – flat rate payment of €15',
    p10: 'The Social plan allows customers who do not have an ecommerce site to share selected products from them via link sharing on social, message and email platforms.\n',
    p10_2:
      'The shared url will carry Logo and Terms&Conditions of BDroppy, and the user who purchases through said URL will for all intents and purposes be considered as a BDroppy customer. An account will be created for it on BDroppy with which it can monitor the status of its orders.\n',
    p10_3:
      'BDroppy for its part will recognize a percentage equal to 10% resulting from the shared URL and upon successful purchase, to the customer active with the Social plan, the amount of which will be credited directly in the Balance section within the profile of the customer active with the Social plan.\n',
    p10_4:
      'BDroppy will also recognize to the customer active with the Social plan a cashback worth 10% on the personal purchases of the same customer, which will be found in his BDroppy profile, under the Balance section.\n',
    p10_5:
      'Payment for orders placed from the links shared by the customer active with the Social plan will be made directly to BDroppy, which will take care of preparing and sending the order to the final customer.\n',
    p10_6:
      'BDroppy will use the virtual wallet of the customer active with the Social plan for crediting the previously indicated percentages. The amounts accumulated here can be used for payment of the customer’s subsequent orders.\n',
    p10_7:
      'The customer may upon reaching the minimum threshold of €100 request that what is collected be transferred to him by bank transfer.\n',
    p10_8:
      'Product sale prices are the list prices which may be occasionally discounted in case of goods in stock.\n',
    p10_9:
      'The billing data entered by the User when purchasing the Social Plan will be reported in the Terms and Conditions and Privacy Policy of the Social Showcase, so it will be the User’s responsibility to ensure that these data are correct and correspond to reality. IDT S.p.A. shall not be held liable in case of incorrect or fraudulent statements.',
    p11: 'In addition to the features already listed in the Dropshipping service included in each Turnkey Site plan:\n',
    p11_2:
      'Site created via WordPress platform with Woocommerce Plugin for Easy plan, with Prestashop platform for Enterprise plan, with the integration of the Catalogue of products made available by IDT S.p.A.\n',
    p11_3: 'Responsive Layout: suitable for both Desktop and Mobile versions\n',
    p11_4_:
      'Monolingual for the Easy plan, up to 3 languages for the Enterprise plan (to be chosen among the 20 available)\n',
    p11_5:
      'Single currency for Easy plan, up to 3 currencies for Enterprise plan (to be chosen among the 24 available)\n',
    p11_6: 'Compatible with all types of browsers\n',
    p11_7:
      'Integrated PayPal+Stripe payment for both the Easy and Enterprise plans.\n',
    p11_8: 'Mailchimp Plugin Installation\n',
    p11_9:
      'Plug-in Elementor installation for both Easy and Enterprise plans\n',
    p11_10: 'Social media connection\n',
    p11_11: 'Automatic synchronization of orders\n',
    p11_12:
      'Marketplace integration: not available for the Easy plan, integration to both Amazon and eBay channels for the Enterprise plan.\n',
    p11_13: 'Technical support: by e-mail or ticket within 48 working hours.',
    p12:
      'The hosting provided by IDT S.p.A. through third parties includes: \n' +
      '\n' +
      'Amazon Web Service Hosting (Recommended for up to 5,000 products) RAM: 1GB /Transfer: 2 TB',
    p13: 'The products are divided into product categories, the site is provided with the selection of the catalog made by the User or with the entire catalogue available on BDroppy.com, the user can subsequently modify and customize his/her offer.',
    p14: 'Following the User will receive by e-mail the request to fill out a form with the request of the following information in order to be able to start processing the User’s site:\n',
    p14_2: 'name of the User Domain that is requested to be activated;\n',

    p14_3:
      'In case of already registered domain, information will be provided with the necessary procedure to correctly redirect the domain to the servers reported by IDT\n',
    p14_4: 'name of the User Domain that is requested to be activated;\n',
    p14_5:
      'if you have already registered your domain, you will be provided with the information necessary to correctly redirect the domain to our servers\n',
    p14_6: 'language\n',
    p14_7: 'currency\n',
    p14_8:
      'Important: without the correct and complete compilation of the form, IDT staff will not be able to proceed with the processing of the site purchased by the User. \n',
    p14_9:
      'The contents of the User Domain, including but not limited to, all information, end customer data, communications, text documents, databases, drawings and any other audiovisual material are owned by the User. In particular, IDT will provide mere models of contractual texts relating to the general conditions of sale and the privacy policy which must be adapted and verified by the User. It is understood that IDT cannot be held in any way responsible for the contents published on the User Domain. IDT undertakes to provide the User with an efficient and adequate hosting service for the activity carried out on the User Domain. It is understood, however, that IDT cannot be held responsible for any problems related to the hosting service that do not depend on their own default or negligence. IDT undertakes to provide the User with a functioning e-commerce site with plugins already installed. It is understood, however, that IDT cannot be held responsible for any malfunctions of the latter or of additional external plugins installed by the User which are incompatible with those already installed by IDT. \n',
    p14_10:
      'The technical management is entirely entrusted to the User. IDT undertakes to deliver the e-commerce site within 15 working days from the reception of the correctly completed form by the customer and to provide free assistance for malfunctions related to the e-commerce site reported by the User by opening a ticket within 7 working days from the time of communication of activation of the site by IDT. Beyond this term, the assistance provided by IDT must be paid according to the rates indicated in Annex A. The Service has a minimum duration of 1 or 12 months, starting from the date of its activation by IDT. The Service will be renewed automatically for the same period unless canceled by the User, cancellation to be sent at least 1 month before the expiry of the Service by email. It is understood that the User will have to pay the Price in effect at the time of each renewal. In the event that the User cancels in the manner and within the deadline set above, he/she can choose whether to completely disable the Service or keep the e-commerce by ceasing to use the dropshipping service offered by IDT by paying, in this case IDT S.p.A. within 7 days will delete the domain from its servers. The User is therefore asked to address the domain to the new server within these times.',
    a1: 'ANNEX A – Subscription types',
    a2: 'ANNEX B – Appointment of the Data Processor',
    annex:
      'SOCIAL – 1 integration (1 list and 1 channel) 29€/month – 290€/year\n',
    annex_1:
      'PLUGIN – 1 integration (1 list and 1 channel) 99€ /month – 990€/year\n',
    annex_2:
      'PLUGIN+ – 3 integrations (3 lists and 3 channels) 199€ /month – 1990€/year\n',
    annex_3:
      'Integrations of your choice among Woocommerce, Prestashop,  Wix, Ecwid and Squarespace.\n',
    annex_4: 'Stock updates are available every 5 minutes\n',
    annex_5: 'Product descriptions in 20 languages\n',
    annex_6: 'High-definition product images\n',
    annex_7: 'Editorial images for advertising purposes\n',
    annex_8: 'Tutorials and sales tips\n',
    annex_9:
      'The price of the turnkey site will be determined by BDroppy based on the customer’s needs. Acceptance of the quote and simultaneous payment of the agreed site price with the reference salesperson is considered acceptance of these Terms and Conditions and the consequent start of the contract with Bdroppy. The service will automatically renew annually\n',
    annex_10:
      'In the case of choosing the Turnkey Site “Easy”,the features are:\n',
    annex_11: 'ECOMMERCE WEBSITE\n',
    annex_12: 'CMS: Woocommerce or Shopify*\n',
    annex_13: '1 language\n',
    annex_14: '1 currency\n',
    annex_15: '“Hosting and Domain included- AWS Hosting \n',
    annex_16: 'Memory RAM: 1GB /Transfer: 2 TB” \n',
    annex_17: '1 basic template\n',
    annex_18: 'Mailchimp Plugin installation\n',
    annex_19: 'Payment gateway installed: Paypal – Stripe\n',
    annex_20: '*Shopify subscription not included\n',
    annex_21:
      'In the case of choosing a Turnkey Site “Professional” the features are:\n',
    annex_22: 'ECOMMERCE WEBSITE\n',
    annex_23: 'CMS Woocommerce\n',
    annex_24: 'Hosting and Domain included- Hosting AWS Memory\n',
    annex_25: 'Memory RAM: 2GB / Transfer: 3TB\n',
    annex_26: '1 integration with the marketplace (Amazon or eBay) included\n',
    annex_27: 'Mono-language site (1 language to choose from 20 available)\n',
    annex_28: 'Mono-currency site (1 currency to choose from 24 available)\n',
    annex_29: 'Installation of Mailchimp plugin\n',
    annex_30: 'Payment gateway installed: Paypal – Stripe\n',
    annex_31:
      'In case of choice of Turnkey Site “Enterprise” the features are:\n',
    annex_32: 'ECOMMERCE WEBSITE\n',
    annex_33: 'CMS Prestashop\n',
    annex_34: 'Hosting and Domain included- Hosting AWS Memory\n',
    annex_35: 'Memory RAM: 2GB / Transfer: 3TB\n',
    annex_36: '2 integrations with marketplaces (Amazon and Ebay)\n',
    annex_37: 'Multilingual site (up to 3 languages of your choice)\n',
    annex_38: 'Multi-currency site (up to 3 currencies of your choice)\n',
    annex_39: 'Installation of Mailchimp plugin\n',
    annex_40: 'Payment gateway installed: Paypal – Stripe',
    annex_2_p1:
      'BETWEEN\n' +
      '\n' +
      'The Client – the Controller –\n' +
      '\n' +
      'AND\n' +
      '\n' +
      'IDT S.p.A., with its registered office in Torino, via Quittengo 35, C.F. – P.IVA 10010450012 – the Processor',
    annex_2_t1: '1. Object, duration, processed personal data',
    annex_2_t2: '2. Processing within the UE and the EEA',
    annex_2_t3: '3. Technical and organizational measures',
    annex_2_t4: '4. Rectification, restriction and erasure of data',
    annex_2_t5: '5. Warranties and other Processor’s obligations',
    annex_2_t6: '6. Sub-tasks',
    annex_2_t7: '7. Controller’s supervisory power',
    annex_2_t8: '8. Controller assistance',
    annex_2_t9: '9. Controller’s executive powers',
    annex_2_t10: '10. Liability',
    annex_2_p2:
      '1.1. The Processor will carry out the following activities: management of shipments to the addresses communicated by and on behalf of the Controller. 1.2. The duration of this appointment is equal to the duration of the main contract. 1.4. The categories of processed personal data are the following: fundamental personal data contact details contractual data purchase history billing and payment information and accounting data others: …………………………………………….. [specify] 1.4. The personal data collected and processed relate to: customers potential customers subscribers employees and partners officers agents and representatives contact point people others …………………………………………….. [specify]',
    annex_2_p3:
      '2.1. The operations of data process regulated by the present appointment contract will be carried out within the European Union (EU) or the European Economic Area (EEA). Any data transfer to a third country outside the EU or the EEA is subjected to prior written authorization by the Controller and can occur only according to specific conditions set out under articles 44 et seq. GDPR 2.2. The legal basis for the transfer under the GDPR are: an adequacy decision by the European Commission (art. 45 par. 3) binding corporate rules (art. 46 par. 2 point b) and art. 47) standard data protection clauses (art. 46 par. 2 points c) and d)) codes of conduct (art. 46 par. 2 point e) and art. 40) a certification mechanism (art. 46 par. 2 point f) and art. 42) others: …………………………………………….. (art. 46 par. 2 point a), par. 3 points a) and b))',
    annex_2_p4:
      '3.1. The Processor ensures the security of processing pursuant to articles 28 par. 3 point c) and 32 GDPR, in particular pursuant to article 5 paragraphs 1 and 2 GDPR. Such measures must ensure the security of data and a level of protection appropriate to the risk for confidentiality, integrity, availability and resilience of the systems. Pursuant to article 32 par. 1 GDPR, the state of the art, implementation costs, nature, object and purposes of processing, as well as the probability of a violation of personal data and the seriousness of the risks potentially deriving from it to natural persons’ rights and freedom, should all be taken into account.',
    annex_2_p4_2:
      ' 3.2. The technical and organisational measures are subjected to technical and technological development and progress. Therefore, the Processor may adopt alternative measures adequate to the changed technological context. In such cases, the level of processing security cannot be reduced. Any substantial modification must be documented.',
    annex_2_p5:
      '4.1. The Processor cannot, rectify, erase or restrict the processing of the data assigned by the Controller on his own initiative, but only upon documented instruction by the Controller.',
    annex_2_p5_2:
      '4.2. Should a data subject contact directly the Processor with regard to a question of processing rectification, erasure or restriction, the Processor shall forward such a request immediately to the Controller. The erasure, rectification, portability and access requests shall be processed without undue delay on the basis of the Controller’s documented instructions.',
    annex_2_p6:
      'In addition to the provisions of the present contract, the Processor is bound to respect all legal requirements outlined in articles 28-33 GDPR. To this end, the Processor ensures to comply in particular with the following conditions: Appointment of a Processor for the Protection of Personal Data (Data Protection Officer, DPO) The current DPO is: Ida Tafuri The Processor will communicate without undue delay every DPO change to the Controller. Confidentiality The processing activity regulated by this appointment contract will be carried out only by employees, partners or appointed people previously instructed by the Processor on the correct processing of personal data and contractually bound by the obligation of confidentiality under articles 28 par. 3(b) and 32 GDPR. The Processor, as well as any other person under his authority and able to access to personal data, shall not process personal data unless instructed to do so by the Controller, not even through the present appointment, unless expressly provided by the law. Technical and organizational measures Implementation and respect of adequate technical and organizational measures in the context of the present appointment contract, pursuant to what specified under article 32 GDPR. The Processor controls periodically the internal procedures and the technical and organizational measures to ensure that the processing within his competent area is compliant with the legal requirements under the discipline of the protection of personal data and data subjects’ rights. The Processor ensures to the Controller the verifiability of the technical and organizational measures among his supervisory powers as set out under point 7 of the present contract. Partnership with supervisory authorities The Controller and the Processor cooperate, under request, with the supervisory authority. The Controller is immediately informed of all inspections and the measures executed by the supervisory authority, in so far as they refer to activities carried out according to this contract. This is true also in case the Processor is subject to or involved in an investigation by a competent authority with regard to a violation of any provision relating to personal data processing occurred in activities pursuant to the present contract. In so far as the Controller is subject to investigation by the supervisory authority, administrative pecuniary sanctions, precautionary measures or criminal proceedings, claims by data subjects or by third parties, or any other legal actions relating to the data processing by the Processor pursuant to the present appointment, the Processo shall do everything possible to support the Controller. ',
    annex_2_p7:
      '6.1. the Processor may delegate part of processing activities regulated by the present contract to further Sub-processors, who shall be subject to the contractual obligations set out under article 28 par. 4 GDPR where provided by the law. 6.2. The Processor appoints from now the following Sub-processors, provided that contractual agreements complying with what required under article 28 par. 2-4 GDPR are concluded:',
    annex_2_p8:
      '7.1. In coordination with the Processor, the Controller has the right to carry out inspections or have an auditor, instructed on each occasion, carry them out. The auditor shall have the right to assess the Processor’s compliance with the present appointment contract as far as it concerns his own entrepreneurial activities, by means of random checks, which shall be communicated in advance as a general rule.',
    annex_2_p8_2:
      '7.2. The Processor shall allow the Controller to verify his compliance with his obligations, as set out in article 28 GDPR. Upon request, the Processor shall provide the Controller with any necessary information as well as, in particular, with evidence of the adoption of technical and organizational measures.',
    annex_2_p8_3:
      ' 7.3. The evidence of the adoption of such measures, which may refer also to activities other than those falling within the scope of the present contract, may be provided also by means of compliance with approved codes of conduct pursuant to article 40 GDPR;L certifications issued according to an approved certification mechanism pursuant article 42 GDPR; current auditors’ certifications, reports or extracts of reports written by independent organs. (e.g. auditors, personal data protection officers, IT security department, data protection auditors) Adequate certifications issued by IT security or personal data protection auditors. 7.4. The Processor may charge the Controller a reasonable remuneration for the inspections execution.',
    annex_2_p9:
      '8.1. The Processor shall assist the Controller in carrying out his obligations relating to the personal data security, in reporting data breaches, in the impact assessments on the data protection and in the pre-emptive consultations referred to in the articles from 32 to 36 GDPR, also ensuring adequate protection standards by means of technical and organizational measures, taking into account nature, circumstances and purposes of processing, probability of data breaches and of the seriousness of the risks deriving from it for natural persons ensuring the immediate detection of infringements reporting without undue delay any data breach to the Controller assisting the Controller in processing data subjects’ requests to exert their rights',
    annex_2_p9_2:
      '8.2. The Processor may request a reasonable remuneration for the assistance services that are not included in the description of the services and that are not due to errors attributable to the Processor.',
    annex_2_p10:
      '9.1. The Processor shall process no personal data pursuant to the present appointment if not under the Controller’s instruction, unless he is bound to do that under the law of the EU or of Member States.',
    annex_2_p10_2:
      ' 9.2. Should the Controller ask for a modification of the personal data processing envisaged in the documented instructions pursuant to point 2, the Processor informs immediately the Controller if he considers that such modification could entail a violation of the provisions on data protection. The Processor may abstain from carrying out any activity that could result in such a violation.',
    annex_2_p11:
      '10.1. Each party of the present contract undertakes to compensate the other for damages or expenses deriving from his own negligent non-compliance with the present contract, including any negligent non-compliance committed by his own legal representative, Subprocessors, employees or other agents. Furthermore, each party undertakes to indemnify the other from any claim by third parties deriving from or relating to any negligent violation committed by the other.',
    annex_2_p11_2:
      '10.2. It remains unchanged the requirement under article 82 GDPR 11. Destruction or returning of personal data\n',
    annex_2_p12:
      '11.1. The Processor does not create copies or duplicates of data unbeknownst to and without the Controller’s consent, except for security copies, in so far as they are necessary to ensure the ordered processing of data, as well as for the data whose storage is required by the law.',
    annex_2_p12_2:
      ' 11.2. Upon the conclusion of the service supply, the Controller may choose to have the Processor erase or return all personal data collected and processed pursuant to the present appointment, in compliance with data protection, unless the applicable legal provisions do not require further conservation of personal data. In any case, the Processor may keep all information necessary to demonstrate the ordered and conformed execution of the processing activities also beyond the termination of the contract, in accordance with the storage period prescribed by the law.',
    annex_2_p12_3:
      ' 11.3. The documents used to demonstrate an ordered processing of data pursuant to the appointment contract shall be stored by the Processor beyond the duration of the contract in compliance with the respective storage period. The Processor may give such documents to the Controller at the end of the duration of the contract to discharge himself from such contractual obligation',
    annex_2_p7_2:
      '6.3. The transfer of data to a Sub-processor may occur only upon satisfaction of all abovementioned conditions for Sub-processors appointment. 6.4. The Processor is integrally responsible for the appointed Sub-processors’ conduct. Any modification to the Sub-processors list must be communicated to the Controller without undue delay, giving the latter the right to object to it. In case of objection, the Processor has the right to withdraw from the contract with the Controller without prior notification. 6.5. In particular, should the Sub-processor work outside the EU/EEA, the Processor shall ensure with adequate means the respect of EU law on personal data protection, as described under point 2 of the present contract.',
    annex_2_t12: '11. Distruzione e restituzione dei dati personali',
  },
  popupNewsletter: {
    wait: 'Aspetta!',
    title: '10% di sconto subito per te!',
    subtitle:
      'Iscriviti e ottieni subito il [subtitleBold] sul tuo primo ordine',
    subtitleBold: '10% di sconto',
    name: 'Nome',
    email: 'Email',
    cta: 'Iscriviti ora!',
    invalidEmail: "L'indirizzo email non è valido",
    registrationSuccess: 'Registrazione avvenuta con successo!',
    disclaimer:
      'Solo per nuovi clienti. Non cumulabile con altri codici sconto. Guarda la nostra [privacy policy] o [contattaci] per maggiori informazioni.',
    privacy: 'privacy policy',
    contattaci: 'contattaci',
    unsubscribe: 'Disiscriviti quando vuoi.',
  },
  popupNewSignup: {
    title: 'GRAZIE PER LA TUA ISCRIZIONE!',
    t1: 'Riceverai tutti gli aggiornamenti da BDroppy sulla tua mail.',
    t2: '10% DI SCONTO',
    t3: 'sul tuo primo ordine con il codice:',
    t4: 'WELCOME10',
    cta: 'Vai alla home',
  },
});
export default translations;
